import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
//import { AuthService } from '@auth0/auth0-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertController, IonAlert, IonLoading, IonModal, ModalController } from '@ionic/angular';
import { NkpBeillesztesComponent } from '../ertekelesek/nkp-beillesztes/nkp-beillesztes.component';
import { OverlayEventDetail } from '@ionic/core/components';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Observable, Subscription, delay, switchMap, take, of, catchError, forkJoin, firstValueFrom } from 'rxjs';
import { LoadingController } from '@ionic/angular';
import { InfiniteScrollCustomEvent } from '@ionic/angular';
import { callbackUri } from '../auth.config';
import { Browser } from '@capacitor/browser';
import moment from 'moment';
//import { KeycloakService } from "keycloak-angular";
//import { KeycloakProfile } from 'keycloak-js';
import { CacheService } from '../cache.service';
import * as CryptoJS from 'crypto-js';
import { DataService } from '../data.service';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { font } from '../util/pdf-fontok/Bitter-Regular-normal'
import { fontB } from '../util/pdf-fontok/Bitter-Bold-normal'
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { tomegesErtekeles, uresekSzama } from '../ertekeles-tomeges';
import { sajatTetelE, jegyModositasBekeres, NEGYEDEV_JEL, NEGYEDEV_NEV, negyedevesE, NEM_IRTA_JEL, nemIrtaE, nemIrtaJelE, nemIrtaModE, strukturaltRovid, stornoOkBekeres } from '../ertekeles-modositas';
import { Router } from '@angular/router';
import { domTablaKinyer, honapCimke, IKON_JELMAGYARAZAT } from '../riport-pdf';


class Port {
  public id: string;
  public name: string;
}

@Component({
  selector: 'app-nyilvantarto',
  templateUrl: './nyilvantarto.component.html',
  styleUrls: ['./nyilvantarto.component.scss'],
})
export class NyilvantartoComponent implements OnInit, OnDestroy {
  today = new Date();
  selectedMonth: any = this.today.getMonth() + 1; // Example: July
  selectedYear: number = this.today.getFullYear(); // Example: Year 2023
  selectedMonthS: any = (this.today.getMonth() + 1).toString(); // Example: July
  selectedYearS: number = this.today.getFullYear(); // Example: Year 2023
  selectedDay: number = this.today.getDate();
  daysInMonth: Day[] = [];
  nyilvantartas = [];
  nyilvantartasR;
  uuid;
  weeksumi = 0;
  nyitotthet = 4
  readWrite = true;
  tomeges = false;
  bulkProcess = false;
  kezdodatum;
  vegsodatum;
  tanfelev;
  isWeekday = (dateString: string) => {
    const date = new Date(dateString);
    const utcDay = date.getUTCDay();

    /**
     * Date will be enabled if it is not
     * Sunday or Saturday
     */
    return utcDay !== 0 && utcDay !== 6;
  };
  isKezdoKisebb = (dateString: string) => {
    const date = new Date(dateString);
    const date2 = new Date(this.kezdodatum);
    const utcDay = date.getUTCDay();
    const utcDay2 = date2.getUTCDay();
    let holidays = this.holidays.map(holiday => new Date(holiday.date).setHours(0, 0, 0, 0));
    let holiday = holidays.includes(date.setHours(0, 0, 0, 0))

    /**
     * Date will be enabled if it is not
     * Sunday or Saturday
     */
    return date > date2 && utcDay !== 0 && utcDay !== 6 && !holiday;
  };

  @ViewChild(IonModal) modal: IonModal;

  @ViewChild(IonAlert) al: IonAlert;
  @ViewChild(IonLoading) loader: IonLoading;

  public alertButtons = [
    {
      text: 'Mégse',
      role: 'cancel',
      handler: () => { },
    },
    {
      text: 'OK',
      role: 'confirm',
      handler: () => {
        this.delete();
      },
    },
  ];

  ports: Port[] = [];
  port: Port;

  erko = '';
  erkp = '';
  tavo = '';
  tavp = '';
  c1 = 1;
  c2 = 1;
  c3 = 0;
  tartoshely = 0
  helyettes = 0
  szivhely = 0
  currentday;
  jelenlet = 1;

  //user$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  public user$ //: KeycloakProfile | null = null;
  userMetadata;
  loading;
  page = 0;
  portsSubscription: Subscription;
  holidays: any[] = []
  munkanapok = 0
  sajatnev
  weekNum = -1//Math.floor(this.getWeekNumber(new Date())[1]/7);
  sajatIntezmeny
  intezmenyek
  portsDef
  napiOrarend

  /*  UTÓLAGOS HELYETTESÍTÉS BEJELENTÉSE - a naplóból, menüváltás nélkül.
   *
   *  A bejelentésnek eddig saját képernyője volt (Helyettesítés bejelentése). Csakhogy
   *  a kolléga akkor jut eszébe, amikor a napját naplózza - ilyenkor kilépni a naplóból,
   *  megkeresni a másik menüt, ott újra kiválasztani ugyanazt a napot: felesleges kör.
   *  Ezért ugyanaz a bejelentés innen is elindítható, UGYANAZOKON a végpontokon.
   *
   *  Amit NEM másolunk ide: a jóváhagyást. Az továbbra is az adminisztrátoré, a saját
   *  képernyőjén - a bejelentés állítás, a helyettesítés tény, és a kettőt nem ugyanaz
   *  a személy mondja ki. Az órarend a jóváhagyásig érintetlen marad.
   */
  helyBe = false;                 // az intézmény bekapcsolta-e a bejelentést
  helyNyitva = false;             // a naplón belüli bejelentő-blokk nyitva van-e
  helyOrak: any[] = null;         // null = még nem kértük le
  /** Tanárra szűrés a bejelenthető órák között (az órarend szerinti tanár). */
  helyTanarSzuro = '';
  get helyTanarok(): string[] {
    return [...new Set((this.helyOrak || []).map((o: any) => String(o.tanar_nev || o.tanar || '')).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'hu'));
  }
  get helySzurtOrak(): any[] {
    const sz = this.helyTarnarErvenyes();
    return (this.helyOrak || []).filter((o: any) => !sz || String(o.tanar_nev || o.tanar || '') === sz);
  }
  /** A kiválasztott tanár, ha az újratöltött listában is szerepel – különben nincs szűrés. */
  private helyTarnarErvenyes(): string {
    return this.helyTanarSzuro && this.helyTanarok.includes(this.helyTanarSzuro) ? this.helyTanarSzuro : '';
  }
  helyFut = false;
  helyValasztott: any = null;
  helyTipus = 'E';
  helyMod = 'H';
  /*  Hányadik óra – nem kötelező szűrő a bejelenthető órák listájához. */
  helyOraSzam: number | null = null;
  helyIndok = '';
  helyKuld = false;
  readonly HELY_TIPUSOK = [{ e: 'E', n: 'Eseti' }, { e: 'T', n: 'Tartós' }];
  readonly HELY_MODOK = [
    { e: 'H', n: 'Helyettesítés' }, { e: 'O', n: 'Összevonás' },
    { e: 'E', n: 'Elmarad' }, { e: 'S', n: 'Szívességi' },
  ];
  napiOraszamMap: { [nap: string]: { relevans: number; naplozott: number; ora: number } } = {}
  napiHelyettesitesMap: { [nap: string]: { eseti: number; tartos: number; kotottTulora?: number } } = {}
  elore
  ertekelesTipus
  files: any = [];
  regifajlok: any = []
  readonly FOKOZAT_GOMBOK = [
    { rovid: 'P', ertek: 'Példás' },
    { rovid: 'J', ertek: 'Jó' },
    { rovid: 'V', ertek: 'Változó' },
    { rovid: 'H', ertek: 'Hanyag' },
  ];

  /*  JEGYBEÍRÁS GOMBOKKAL.
   *
   *  Az érdemjegy öt értéket vehet fel, mégis szabad szövegmező volt hozzá: a tanár
   *  gépelt, mobilon számbillentyűzet nyílt, és egy félreütésből 55 lett. Egy koppintás
   *  ugyanazt elintézi – ahogy a mellette álló „–" (nem írta meg) gomb is.
   *
   *  A százalékos (mód 2) és a fokozatos (mód 4) értékelés NEM érintett: ott a gombsor
   *  nem segítene, azoknak megvan a saját beviteli módjuk. A kapcsoló az 1–5 jegyre hat.
   */
  readonly JEGY_GOMBOK = ['1', '2', '3', '4', '5'];
  //  Az alapérték a gombos mód; a kiszolgáló válasza írja felül, ha az iskola kikapcsolta.
  jegyGombok = true;

  /** Ezt a jegyet mutatja-e a cella (a gomb kitöltött állapotához). */
  jegyEgyezik(ertek: any, gomb: string): boolean {
    return String(ertek ?? '').trim() === String(gomb);
  }

  /*  Ugyanarra a gombra újra koppintva TÖRÖL. Enélkül a tévesen megnyomott jegyet
   *  csak a sor újratöltésével lehetne visszavonni – gombsornál nincs hova „kitörölni". */
  jegyGombra(sor: any, gomb: string) {
    if (!sor) return;
    sor.osztalyzat = this.jegyEgyezik(sor.osztalyzat, gomb) ? '' : String(gomb);
  }

  /** Gombsorral írjuk-e a jegyet ennél az óránál? */
  jegyGombosMod(ora: any): boolean {
    return this.jegyGombok && String(ora?.osztalyozasimod ?? '') !== '2';
  }
  /*  A BEÁLLÍTÁST A KISZOLGÁLÓTÓL KÉRDEZZÜK, nem a belépéskor eltárolt intézmény-adatból:
   *  az adminban most átállított érték azonnal éljen, ne csak ki- és belépés után.
   *  Ha nem jön válasz, marad a gombos mód – az az alapértelmezés. */
  private jegyBeallitasBetolt(http: any, intezmenyId: any) {
    const ut = String(intezmenyId || '').replace(/^\/+|\/+$/g, '');
    if (!ut) return;
    http.get(`/api/ertekeles/beallitas/${ut}`).subscribe({
      next: (v: any) => { this.jegyGombok = v?.jegy_gombok !== false; },
      error: () => { /* marad az alapértelmezés */ },
    });
  }



  data: any[];
  private cacheSubscription: Subscription;
  statuszok = [
    ["alert", "danger", "Nincs adat"],
    ["checkmark-circle-outline", "success", "Dolgozik"],
    ["bed", "tertiary", "Fizetett szabadság"],
    ["medkit", "warning", "Betegszabadság / táppénz"],
    ["car", "secondary", "Iskolai kiküldetés"],
    ["ban", "dark", "Fizetés nélküli szabadság"],
    ["leaf", "success", "Nincs tanítási órám"],
    ["globe", "secondary", "Digitális távoktatás"],
    ["hourglass-outline", "dark", "Nincs adat"]
  ];
  jelenletText = [
    "",
    "Dolgozik",
    "Fizetett szabadság",
    "Betegszabadság / táppénz",
    "Iskolai kiküldetés",
    "Fizetés nélküli szabadsá",
    "Nincs tanítási órám",
    "Digitális távoktatás",
  ]

  submittype = "0"

  szabadsag: any = {}
  utazas: any = {}
  statsDisplay = {
    bookedDays: 0,
    incompleteDays: 0,
    hours: '0.00',
    travelKm: 0,
    remainingVacation: 0,
    usedVacationInMonth: 0,
    remainingSickLeave: 0,
    usedSickLeaveInMonth: 0,
  }
  moment: any = moment;
  @ViewChild("ertekelesmodal") ertekelesmodal: IonModal;
  @ViewChild("hazifeladatmodal") hazifeladatmodal: IonModal;
  @ViewChild("elozmenymodal") elozmenymodal: IonModal;
  /*  AZ ÓRA ELŐZMÉNYE (backend/ora-naplo.js): ki írta be, ki javította, mit mire, ki törölte. */
  elozmenyOra: any = null;
  elozmenyAdat: any = null;
  elozmenyBetolt = false;
  /*  LEZÁRT NAP (backend/naplo-zaras.js): a kiszolgáló tiltja a módosítást; itt csak kiírjuk. */
  napLezart: string | null = null;
  readonly MUVELET_NEV: Record<string, string> = {
    beiras: 'Beírás (könyvelés)', javitas: 'Javítás', modositas: 'Módosítás', konyveles_torles: 'Könyvelés visszavonása',
    helyettesites: 'Helyettesítés', elmaradt: 'Elmaradtnak jelölve', elmaradt_vissza: 'Elmaradt jelölés visszavonva',
    torles: 'Törlés', visszaallitas: 'Visszaállítás', atallitas: 'Átállítás (rendszer)',
    //  Az osztályfőnöki utak (mulasztás-rács, napokra igazolás, visszavonás, hiányzás-törlés) – app.js › mul_naploUtan.
    igazolas: 'Igazolás / mulasztás (osztályfőnök)', igazolas_visszavonas: 'Igazolás visszavonása (osztályfőnök)',
    hianyzas_torles: 'Hiányzás törlése (osztályfőnök)',
  };
  /*  Az igazolás-bejegyzés „oktazon:típus” párokból áll (ora-naplo.js › igazolasLista); a típus
   *  a `mulasztas_tipus` törzs szerint, -2 = igazolatlan. */
  readonly IGAZOLAS_TIPUS_NEV: Record<string, string> = {
    '1': 'orvosi', '2': 'gondviselői', '3': 'iskolaérdekű', '4': 'hivatalos', '5': 'kikérő / igazgatói engedély',
    '6': 'egyéb', '7': 'pályaválasztási', '-2': 'igazolatlan', '-3': 'igazolatlan',
  };
  readonly MEZO_NEV: Record<string, string> = {
    tema: 'Téma', hazifeladat: 'Házi feladat', hianyzo: 'Hiányzók', igazolas: 'Igazolás', hazihiany: 'Házi hiány',
    felszhiany: 'Felszereléshiány', felmentes: 'Felmentés', dicseret: 'Dicséret', jelenvolt: 'Jelen volt',
    konyvelte: 'Beíró', konyvelve: 'Beírás ideje', helyettesites: 'Helyettesítés', helyettesito: 'Helyettesítő',
    helyettesites_tipus: 'Helyettesítés típusa', helyettesites_mod: 'Helyettesítés módja', elmaradt: 'Elmaradt', elmaradt_ok: 'Elmaradás oka',
  };
  kivalasztottOra
  tanoraformelleklet

  constructor(
    //public auth: AuthService,
    private http: HttpClient,
    private ref: ChangeDetectorRef,
    private loadingCtrl: LoadingController,
    //public keycloak: KeycloakService,
    public auth: AuthService,
    public oauth: OAuthService,
    private cacheService: CacheService,
    public changeref: ChangeDetectorRef,
    private datas: DataService,
    private router: Router,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {

    /*this.ports = [
      { id: 1, name: 'Tokai' },
      { id: 2, name: 'Vladivostok' },
      { id: 3, name: 'Navlakhi' },
    ];*/
    /*this.auth.idTokenClaims$.subscribe((idTokenClaims) => {
      // Extract the user_metadata claim from the ID token
      this.uuid = idTokenClaims['sub'];
      this.port = { id: idTokenClaims['sub'], name: idTokenClaims['name'] };
      //console.log(idTokenClaims['https://claims.vszc/uuid']);
    });*/

  }
  async ngOnInit() {
    //let isLoggedIn = await this.oauth.hasValidAccessToken();
    //if (isLoggedIn && (await this.datas.getFromStorage("userMetadata")).intezmenyadatok) {
    await this.oauth.loadUserProfile();
    this.user$ = this.datas.belepoKilet(this.oauth.getIdentityClaims()) as any;
    this.userMetadata = (await this.datas.getFromStorage("userMetadata"))
    //this.userMetadata.department = "rendszergazda"
    //  A token nem mindig hordozza a `username` mezőt – a `preferred_username` a biztos.
    this.uuid = this.user$?.username || this.user$?.preferred_username
    //this.getMeta();
    this.sajatnev = this.userMetadata.viselt_vez + " " + this.userMetadata.viselt_ker//this.user$.attributes.name
    //console.log(this.userMetadata.intezmenyadatok)
    //console.log(JSON.parse(this.userMetadata.intezmenyadatok))
    this.sajatIntezmeny = (await this.datas.getFromStorage("sajatIntezmeny"))
    this.helyBeallitasBetolt();
    this.jegyBeallitasBetolt(this.http, this.sajatIntezmeny?.intezmenyId);
    try {
      const akttev = JSON.parse(await this.datas.getFromStorage("tanev")).aktualistanev;
      const tanev = JSON.parse(await this.datas.getFromStorage("tanevadatok")).find((d: any) => d.id == akttev);
      this.tanfelev = tanev?.felev ? moment(tanev.felev).format("YYYY-MM-DD") : null;
    } catch (error) {
      this.tanfelev = null;
    }
    this.intezmenyek = this.userMetadata.intezmenyadatok.sort((a, b) => (a.intezmenyName > b.intezmenyName) ? 1 : ((b.intezmenyName > a.intezmenyName) ? -1 : 0))

    this.showLoading('Adatok betöltése...').then(() => {
      //this.cacheSubscription = this.cacheService.cache$.subscribe(data => {

      this.getMunkatarsakNew()
      //});



      //this.getMeta();
      this.weekNum = this.getWeekOfMonth(this.today);
    });
    //}
  }
  ngOnDestroy(): void {
    clearTimeout(this.autoBetoltesIdozito);
    // We unsubscribe from the cache and clear the cache data when the component is destroyed.
    //this.cacheSubscription.unsubscribe();
    sessionStorage.removeItem('allomany');
    //this.cacheService.clear('a'); // you can adapt this according to your logic to clear the cache
  }

  formatErtekelesRovid(ertekeles: any): string {
    const value = String(ertekeles ?? '').trim();
    const fokozatMap: Record<string, string> = {
      'Példás': 'P',
      'Jó': 'J',
      'Változó': 'V',
      'Rossz': 'H',
      'Hanyag': 'H',
      'R': 'H',
    };

    // A '/' csak a magatartás/szorgalom formátumnál jelent kettéosztást (pl.
    // "Példás / Jó"), ahol minden rész rövid fokozat. Egy '/' jelet TARTALMAZÓ
    // szöveges értékelést NEM szabad így kezelni – az lentebb 'SZ' lesz.
    if (value.includes('/')) {
      const reszek = value.split('/').map((resz) => resz.trim());
      const csakFokozat = reszek.every((resz) => !!fokozatMap[resz] || resz.length <= 4);
      if (csakFokozat) {
        return reszek.map((resz) => fokozatMap[resz] || resz).join(' / ');
      }
    }

    if (fokozatMap[value]) return fokozatMap[value];
    //  Szám (pl. NKP-eredmény „48.5%”) sosem „SZ”: az a hosszú szöveges értékelés rövidítése.
    if (/^-?\d+([.,]\d+)?\s*%?$/.test(value)) return value.replace(/^(-?\d+)[.,]\d+/, '$1').replace(/\s+/g, '');
    if (value.length > 4) return 'SZ';
    return value;
  }

  getSpecialErtekelesReszletek(ertekeles: any): { magatartas: string; szorgalom: string } | null {
    const value = String(ertekeles ?? '').trim();
    if (!value.includes('/')) return null;

    const [magatartasRaw, szorgalomRaw] = value.split('/').map((resz) => resz.trim());
    return {
      magatartas: this.formatErtekelesRovid(magatartasRaw),
      szorgalom: this.formatErtekelesRovid(szorgalomRaw),
    };
  }

  private isMeaningfulErtekelesItem(item: any): boolean {
    return !!item && typeof item === 'object' && Object.keys(item).length > 0;
  }

  private isZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '2' || modja === '3') return true;
    //  Évközi és negyedéves jegy nem záró – a negyedéves a hónapjában jelenik meg.
    if (modja === '1' || negyedevesE(item)) return false;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('félév')
      || tipusNev.includes('felev')
      || tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  private isEvvegiZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '3') return true;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  private getNumericErtekeles(ertekeles: any): number | null {
    if (ertekeles === undefined || ertekeles === null) return null;
    if (typeof ertekeles === 'number') return Number.isFinite(ertekeles) ? ertekeles : null;

    const raw = String(ertekeles).trim();
    if (!raw || raw.includes('/')) return null;

    const match = raw.match(/-?\d+(?:[.,]\d+)?/);
    if (!match) return null;

    const parsed = Number(match[0].replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  }

  private getMonthKeyFromTargynap(targynap: any): string | null {
    if (!targynap) return null;

    const d = moment(targynap);
    if (!d.isValid()) return null;

    const month = d.month() + 1;
    if (month === 1) {
      const cutoff = moment(this.tanfelev, 'YYYY-MM-DD', true);
      if (cutoff.isValid() && cutoff.month() === 0) {
        return d.isSameOrBefore(cutoff, 'day') ? '01/I' : '01/II';
      }

      return d.date() <= 19 ? '01/I' : '01/II';
    }

    return String(month).padStart(2, '0');
  }

  private getErtekelesSuly(item: any): number {
    const raw = item?.szorzo ?? item?.suly ?? item?.súly;
    if (raw === undefined || raw === null || raw === '') return 1;

    const value = typeof raw === 'number'
      ? raw
      : Number(String(raw).trim().replace(',', '.').replace('%', ''));

    /*  A 0 SÚLY IS SÚLY – és épp az a lényege.
     *
     *  A `<= 0` ág miatt a nullás szorzóból 1 lett: a „Diagnosztikus mérés (0x)"
     *  teljes súllyal számított bele az átlagba, pedig azért van 0-ra állítva, hogy
     *  NE számítson. Csak az értelmezhetetlen érték (hiányzó, szöveg, negatív) esik
     *  vissza 1-re; a kimondott 0 megmarad, és a hívó szűri ki (`weight > 0`).      */
    if (!Number.isFinite(value) || value < 0) return 1;
    return value > 10 ? value / 100 : value;
  }

  private calculateErtekelesAtlag(items: any[]): { atlag: number | null; db: number; szazalek: boolean } {
    const ertekek = (items || [])
      //  A negyedéves értékelés sem számít: összegzi az évközi jegyeket, nem újabb jegy.
      //  A „nem írta meg” (–) sem: az még nem jegy.
      .filter((item: any) => this.isMeaningfulErtekelesItem(item) && !this.isZaroErtekelesItem(item) && !negyedevesE(item) && !nemIrtaE(item))
      .map((item: any) => ({
        value: this.getNumericErtekeles(item?.ertekeles),
        weight: this.getErtekelesSuly(item),
        szazalek: item?.ertek_forma === 'szazalek' || String(item?.ertekeles ?? '').trim().endsWith('%'),
      }))
      .filter((item: { value: number | null; weight: number; szazalek: boolean }): item is { value: number; weight: number; szazalek: boolean } =>
        Number.isFinite(item.value as number) && Number.isFinite(item.weight) && item.weight > 0
      );

    if (!ertekek.length) return { atlag: null, db: 0, szazalek: false };

    const weightedSum = ertekek.reduce((sum, item) => sum + item.value * item.weight, 0);
    const weightSum = ertekek.reduce((sum, item) => sum + item.weight, 0);
    const atlag = weightedSum / weightSum;
    return { atlag: Math.round(atlag * 1000) / 1000, db: ertekek.length, szazalek: ertekek.every((e) => e.szazalek) };
  }

  /** A „%” csak százalékos jegyek átlagához jár – egy ötös átlaga nem „5,0%”. */
  formatAtlag(atlag: any, szazalek = false): string {
    const value = Number(atlag);
    if (!Number.isFinite(value)) return '-';
    const decimals = this.getAtlagTizedesek();
    const formatted = value.toFixed(decimals).replace('.', ',');
    return szazalek ? `${formatted}%` : formatted;
  }

  private getAtlagTizedesek(): number {
    const raw = this.sajatIntezmeny?.ertekelesAtlagTizedes ?? this.sajatIntezmeny?.ertekeles_atlag_tizedes ?? 1;
    const value = Number(raw);
    if (!Number.isFinite(value)) return 1;
    return Math.min(3, Math.max(0, Math.trunc(value)));
  }

  /*  A MÓD A MEGLÉVŐ JEGYEKHEZ IGAZODIK. Ha a tantárgy jegyei ebben a csoportban/osztályban
   *  már egyféle formában vannak (pl. mind százalék), az ablak abban nyílik: a kiszolgáló
   *  eltérő formát úgysem fogad el, és így nem a mentésnél derül ki. Egyébként 1-5. */
  private meglevoFormaSzerintiMod() {
    const MOD: Record<string, string> = { erdemjegy: '1', szazalek: '2', szoveges: '3', fokozat: '4' };
    // Csak az IDEI tanév jegyei számítanak – a kiszolgáló is ezeket nézi.
    const ma = moment();
    const tanevKezd = `${ma.month() >= 7 ? ma.year() : ma.year() - 1}-08-01`;
    const formak = new Set<string>();
    for (const tanulo of Object.values(this.kivalasztottOra?.ertekelesek || {}) as any[]) {
      for (const lista of Object.values(tanulo?.months || {}) as any[]) {
        for (const j of (Array.isArray(lista) ? lista : [])) {
          const f = String(j?.ertek_forma ?? '').trim();
          const nap = String(j?.targynap ?? j?.created_at ?? '').slice(0, 10);
          if (MOD[f] && String(j?.modja ?? '1') === '1' && nap >= tanevKezd) formak.add(f);
        }
      }
    }
    if (formak.size === 1) this.kivalasztottOra.osztalyozasimod = MOD[[...formak][0]];
  }

  private normalizeErtekelesekResponse(ertekelesek: any): any {
    if (!ertekelesek || typeof ertekelesek !== 'object') return {};

    const normalized: any = {};

    Object.entries(ertekelesek).forEach(([oktazon, adat]: [string, any]) => {
      const monthsRaw = adat?.months && typeof adat.months === 'object' ? adat.months : {};
      const months: any = {};
      const felevi: any[] = [];
      const evvegi: any[] = [];

      const addRegularItemToMonth = (item: any) => {
        const monthKey = this.getMonthKeyFromTargynap(item?.targynap ?? item?.datum ?? item?.created_at);
        if (!monthKey) return;
        if (!months[monthKey]) months[monthKey] = [];
        months[monthKey].push(item);
      };

      const sortZaroOrRegular = (item: any) => {
        if (!this.isMeaningfulErtekelesItem(item)) return;
        if (!this.isZaroErtekelesItem(item)) {
          addRegularItemToMonth(item);
          return;
        }

        if (this.isEvvegiZaroErtekelesItem(item)) evvegi.push(item);
        else felevi.push(item);
      };

      (Array.isArray(adat?.felevi) ? adat.felevi : []).forEach(sortZaroOrRegular);
      (Array.isArray(adat?.evvegi) ? adat.evvegi : []).forEach(sortZaroOrRegular);

      Object.entries(monthsRaw).forEach(([monthKey, items]: [string, any]) => {
        if (!monthKey || monthKey === 'unknown') return;
        const normalizedMonthKey = monthKey === '9' ? '09' : monthKey;
        if (!months[normalizedMonthKey]) months[normalizedMonthKey] = [];

        (Array.isArray(items) ? items : []).forEach((item: any) => {
          if (!this.isMeaningfulErtekelesItem(item)) return;
          if (this.isZaroErtekelesItem(item)) {
            if (this.isEvvegiZaroErtekelesItem(item)) evvegi.push(item);
            else felevi.push(item);
            return;
          }
          months[normalizedMonthKey].push(item);
        });
      });

      const elsoFelevAtlag = this.calculateErtekelesAtlag(['09', '10', '11', '12', '01/I'].flatMap((key) => months[key] || []));
      const evesAtlag = this.calculateErtekelesAtlag(['09', '10', '11', '12', '01/I', '01/II', '02', '03', '04', '05', '06'].flatMap((key) => months[key] || []));

      normalized[oktazon] = {
        ...adat,
        months,
        felevi,
        evvegi,
        atlagErtekelesFelev: elsoFelevAtlag.atlag,
        atlagErtekelesFelevDb: elsoFelevAtlag.db,
        atlagErtekelesFelevSzazalek: elsoFelevAtlag.szazalek,
        atlagErtekeles: evesAtlag.atlag,
        atlagErtekelesDb: evesAtlag.db,
        atlagErtekelesSzazalek: evesAtlag.szazalek,
      };
    });

    return normalized;
  }

  isMagatartasSzorgalomTantargy(): boolean {
    const tantargy = String(this.kivalasztottOra?.tantargy || '').toLowerCase();
    return tantargy.includes('magatart') && tantargy.includes('szorgalom');
  }

  applySpecialErtekelesDefaults() {
    if (!this.kivalasztottOra || !this.isMagatartasSzorgalomTantargy()) return;

    this.kivalasztottOra.osztalyozasimod = '4';

    const beszamoloId = this.getBeszamoloTipusId();
    if (beszamoloId) {
      this.kivalasztottOra.szam_tipus = beszamoloId;
    }

    this.ensureSpecialTanuloFields();
  }

  /** A választóban felkínált típusok: a rejtett nem választható, hacsak nem épp az van kiválasztva. */
  valaszthatoTipusok(kivalasztott: any): any[] {
    return (this.ertekelesTipus || []).filter((t: any) =>
      !Number(t?.rejtett) || String(t?.id) === String(kivalasztott ?? ''));
  }

  getBeszamoloTipusId(): string | null {
    //  A magatartás/szorgalom a 20-as technikai („-”) típust kapja, mint az értékelések
    //  oldalon. NÉV szerint nem keressük: a típusok átnevezhetők, és egy „Beszámoló”-ra
    //  átírt rendes típus csendben átvenné a helyét.
    return '20';
  }

  ensureSpecialTanuloFields() {
    if (!this.isMagatartasSzorgalomTantargy() || !this.kivalasztottOra?.osztaly_nevsor) return;

    this.kivalasztottOra.osztaly_nevsor = this.kivalasztottOra.osztaly_nevsor.map((tanulo: any) => ({
      ...tanulo,
      osztalyzat: tanulo?.osztalyzat ?? '',
      szorgalomodost: tanulo?.szorgalomodost ?? '',
    }));
  }

  isDualFokozatMode(): boolean {
    return this.isMagatartasSzorgalomTantargy() && this.kivalasztottOra?.osztalyozasimod === '4';
  }

  getCombinedDualFokozat(tanulo: any): string {
    const magatartas = this.formatErtekelesRovid(tanulo?.osztalyzat || '').trim();
    const szorgalom = this.formatErtekelesRovid(tanulo?.szorgalomodost || '').trim();

    if (magatartas && szorgalom) return `${magatartas} / ${szorgalom}`;
    return magatartas || szorgalom || '';
  }
  setSubmitType(id) {
    this.submittype = id
  }
  setWeekNum(id) {
    this.weekNum = id;
    //let dim = this.daysInMonth
    //this.daysInMonth.filter(item => item.week === id-1);
    //setTimeout(() => this.daysInMonth = dim, 0);
    this.daysInMonth = [...this.daysInMonth]
    this.changeref.detectChanges()
  }
  weekCount(mode = 0) {

    // month_number is in the range 1..12

    var firstOfMonth = new Date(this.selectedYear, this.selectedMonth - 1, 1);
    var lastOfMonth = new Date(this.selectedYear, this.selectedMonth, 0);

    const firstDayOffset = (firstOfMonth.getDay() + 6) % 7;
    var used = firstDayOffset + lastOfMonth.getDate();



    return new Array(Math.ceil(used / 7));

  }

  KezdoDatumChanged(e) {
    this.isKezdoKisebb
    this.ref.detectChanges();
  }

  // A választók (tárgyév, tárgyhónap) változására automatikusan betöltünk – nincs külön Keresés gomb.
  // A rövid késleltetés a gépelt évszámot és a gyors hónap-léptetést egyetlen lekérésbe vonja össze.
  private autoBetoltesIdozito: any = null;
  // Minden getData-hívás kap egy sorszámot; a késve érkező, már elavult válasz nem írja felül a frisset.
  private adatKeresSorszam = 0;

  valasztoValtozott() {
    clearTimeout(this.autoBetoltesIdozito);
    this.autoBetoltesIdozito = setTimeout(() => this.searchM(), 400);
  }

  // Előző / következő hónap; évhatáron az évet is lépteti, majd betölt.
  honapLep(irany: number) {
    let ev = Number(this.selectedYearS);
    if (!Number.isInteger(ev) || ev < 2000 || ev > 2100) ev = Number(this.selectedYear) || this.today.getFullYear();
    let ho = (Number(this.selectedMonthS) || Number(this.selectedMonth) || 1) + irany;
    if (ho < 1) { ho = 12; ev--; }
    if (ho > 12) { ho = 1; ev++; }
    this.selectedYearS = ev;
    this.selectedMonthS = ho.toString();
    this.valasztoValtozott();
  }

  // A választókban álló (még be nem töltött) évet/hónapot érvényesíti; true, ha változott az időszak.
  private idoszakRogzit(): boolean {
    clearTimeout(this.autoBetoltesIdozito);
    const ev = Number(this.selectedYearS);
    const ho = Number(this.selectedMonthS);
    // Félig begépelt / érvénytelen évszámnál még nem kérdezünk le.
    if (!Number.isInteger(ev) || ev < 2000 || ev > 2100 || !(ho >= 1 && ho <= 12)) return false;
    if (ev == Number(this.selectedYear) && ho == Number(this.selectedMonth)) return false;
    this.selectedYear = ev;
    this.selectedMonth = ho;
    return true;
  }

  async searchM() {
    // Ugyanarra az időszakra nem töltünk újra (pl. ugyanaz a hónap újra kiválasztva).
    if (!this.idoszakRogzit()) return;
    await this.showLoading('Adatok lekérése...');
    this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
    this.getData(this.selectedYear, this.selectedMonth)
  }

  isRobotJelenletAdmin(): boolean {
    const values = [
      this.userMetadata?.department,
      this.userMetadata?.jogkor,
      this.user$?.jogkor,
      this.user$?.realm_access?.roles,
    ].flatMap((value: any) => Array.isArray(value) ? value : [value])
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value).toLowerCase());

    return values.some((value) =>
      value === 'admin' ||
      value === 'madmin' ||
      value === 'rendszergazda'
    );
  }

  isElozoHonap(): boolean {
    const selected = moment(`${this.selectedYearS}-${String(this.selectedMonthS).padStart(2, '0')}-01`, 'YYYY-MM-DD', true);
    return selected.isValid() && selected.isBefore(moment().startOf('month'), 'month');
  }

  // Egy adott nap a mai naphoz képest a jövőben van-e (előre rögzíthető szabadság).
  // A korábbi inline feltétel a jövő évi hónapokat (pl. júliust) tévesen szűrte.
  jovobeliNap(day: any): boolean {
    const cm = this.today.getMonth() + 1;
    const cy = this.today.getFullYear();
    const sm = Number(this.selectedMonth);
    const sy = Number(this.selectedYear);
    if (sy !== cy) return sy > cy;
    if (sm !== cm) return sm > cm;
    return Number(day?.dayNumber) > this.today.getDate();
  }

  async robotJelenlet() {
    this.selectedYear = this.selectedYearS;
    this.selectedMonth = this.selectedMonthS;

    if (!this.isRobotJelenletAdmin() || !this.isElozoHonap()) return;

    const ok = window.confirm('Biztosan kitöltsem robotjelenléttel az üres napokat a kiválasztott korábbi hónapban? A már rögzített napokat nem módosítja.');
    if (!ok) return;

    await this.showLoading('Robotjelenlét kitöltése...');
    this.http.post(
      '/api/nyilvantartas/robotjelenlet/' +
      this.selectedYear +
      '/' +
      this.selectedMonth +
      '/' +
      this.uuid +
      '/' +
      this.sajatIntezmeny.intezmenyId,
      { intezmeny: this.sajatIntezmeny.om }
    ).subscribe({
      next: (response: any) => {
        try {
          this.loading.dismiss();
        } catch (e) {
        }
        this.datas.sendToast(`Robotjelenlét kész: ${response?.inserted || 0} nap kitöltve.`, 'success');
        this.refreshStatsPanel(this.selectedYear, this.selectedMonth);
        this.getData(this.selectedYear, this.selectedMonth);
      },
      error: (error) => {
        try {
          this.loading.dismiss();
        } catch (e) {
        }
        console.error('Robotjelenlét hiba:', error);
        this.datas.sendToast('Nem sikerült kitölteni a robotjelenlétet.', 'error');
      }
    });
  }

  resetM() {
    this.selectedMonth = this.today.getMonth() + 1; // Example: July
    this.selectedYear = this.today.getFullYear(); // Example: Year 2023
    this.selectedMonthS = (this.today.getMonth() + 1).toString(); // Example: July
    this.selectedYearS = this.today.getFullYear(); // Example: Year 2023
    this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
    this.getData(this.selectedYear, this.selectedMonth)
  }

  getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    let yearStart: any = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
  }
  getWeekOfMonth(date) {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = (firstDayOfMonth.getDay() + 6) % 7; // Monday=0, Sunday=6
    const dayOfMonth = date.getDate();

    // Calculate full weeks to passed days in the month plus the shift of the start day of the week
    return Math.ceil((dayOfMonth + firstDayOfWeek) / 7);
  }

  diffDateHours(start, end) {
    try {
      return (
        Math.abs(new Date(end).getTime() - new Date(start).getTime()) / 36e5
      ).toFixed(2);
    } catch (error) {
      return '-';
    }
  }

  async ertekeles(event, ora, reload = false) {
    if (event) event.stopPropagation()
    await this.datas.showLoading("Értékelések betöltése...")
    if (this.kivalasztottOra !== ora) this.ertekelesNevSzuro = ''
    this.kivalasztottOra = ora
    /*  AZ OSZTÁLYOZÁSI MÓD CSAK AZ ABLAK MEGNYITÁSAKOR ÁLL ALAPÉRTÉKRE.
     *
     *  Mentés után a képernyő újratölti a jegyeket (`reload`), és eddig ilyenkor a
     *  mód VISSZAUGROTT a Százalékra – akkor is, ha a tanár épp 1-5 jegyet írt be.
     *  A következő adag így csendben százalékként ment el: az 5-ből „5%" lett.
     *  Újratöltéskor tehát a tanár választását tartjuk meg. */
    /*  Alapból az 1-5-ös osztályzat: a jegyek túlnyomó része ilyen, a százalékot külön
     *  kell választani (a tanárok kérése, 2026-09-18). */
    if (!reload || !this.kivalasztottOra.osztalyozasimod) {
      this.kivalasztottOra.osztalyozasimod = "1"
    }
    this.http
      .get(
        // Az n8n-webhook helyett a backend saját végpontja (ugyanaz a válasz-alak).
        /*  A BONTOTT ÓRA OSZTÁLY NÉLKÜL ÁLL. A csoportos órarendi sor `osztalyid`-je
         *  üres (élesben az órák csaknem fele ilyen), a csoportot viszont hordozza.
         *  Eddig ilyenkor üres osztály ment ki, a végpont 400-zal felelt, és a jegy-
         *  ablak meg sem nyílt – a kolléga a csoportjainál nem tudott jegyet beírni. */
        '/api/ertekeles/lekeres?tantargy=' + ora.tantargyid
          //  Csoportos órán a CSOPORT a tanítási egység (akkor is, ha osztály is áll a soron) –
          //  különben az egész osztály jegyei jöttek volna a csoport tagjai helyett.
          + (ora.csoport ? '&csoport=' + ora.csoport : '&osztaly=' + (ora.osztalyid || ''))
          + '&intezmeny=' + encodeURIComponent(this.sajatIntezmeny?.intezmenyId || ''),
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          //this.holidays = response
          this.kivalasztottOra.ertekelesek = this.normalizeErtekelesekResponse(response)
          if (!reload) this.meglevoFormaSzerintiMod()
          this.applySpecialErtekelesDefaults()
          this.datas.hideLoading()
          if (!reload) this.ertekelesmodal.present()
        },
        error: (error) => {
          this.datas.hideLoading()
          console.error('Error fetching data:', error);
          this.datas.sendToast("Hiba történt: " + error, "error")
        },
      });
    //this.ertekelesmodal.present()
  }
  async hazifeladat(event, ora) {
    this.tanoraformelleklet = ora
    this.files = []
    this.regifajlok = []
    await this.datas.showLoading("Fájlok lekérése...")
    this.http
      .get(
        '/api/hazifiles?tanora=' + ora.id
          + '&intezmeny=' + encodeURIComponent(this.sajatIntezmeny?.intezmenyId || ''),
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.datas.hideLoading()
          this.hazifeladatmodal.present()
          console.log(response)
          this.regifajlok = response
        },
        error: (error) => {
          this.datas.hideLoading()
          console.error('Error fetching data:', error);
        },
      });
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  TÖMEGES ÉRTÉKELÉS
   *
   *  Egy dolgozat után 25 tanulónak egyenként beírni ugyanazt a jegyet fölösleges
   *  kattintás. A típust a fenti választó adja, tehát ez BÁRMELYIK értékelési
   *  típusnál működik – csak az értéket írjuk be a névsorba, a mentés a megszokott.
   * ═══════════════════════════════════════════════════════════════════ */

  /** A számmezős (jegy/százalék) tömeges kitöltés beviteli értéke. */
  tomegesErtekMezo: any = '';

  get tomegesUresek(): number {
    return uresekSzama(this.kivalasztottOra?.osztaly_nevsor || []);
  }

  /**
   *  @param ertek    a beírandó érték ('' = törlés)
   *  @param hatokor  'mind' = mindenkinek, 'ures' = csak akinek még nincs
   *  @param mezo     fokozat-módban a szorgalom külön mező
   */
  tomegesErtek(ertek: any, hatokor: 'mind' | 'ures' = 'mind', mezo: 'osztalyzat' | 'szorgalomodost' = 'osztalyzat') {
    const nevsor = this.kivalasztottOra?.osztaly_nevsor || [];
    if (!nevsor.length) return;
    const db = tomegesErtekeles(nevsor, ertek, hatokor, mezo);
    const mit = String(ertek ?? '').trim() === '' ? 'törölve' : `„${ertek}" beírva`;
    this.datas.sendToast(`${db} tanulónál ${mit}${hatokor === 'ures' ? ' (csak az üresek)' : ''}.`,
      db ? 'success' : 'warning');
  }

  /** A számmezőbe írt érték kiosztása. */
  tomegesSzam(hatokor: 'mind' | 'ures' = 'mind') {
    const ertek = String(this.tomegesErtekMezo ?? '').trim();
    if (!ertek) { this.datas.sendToast('Előbb add meg az értéket.', 'warning'); return; }
    this.tomegesErtek(ertek, hatokor);
  }

  /*  Üres témára RÁKÉRDEZÜNK — lásd az Értékelések képernyő azonos szabályát. */
  private temaKerdezve = false;

  private temaRendben(): boolean {
    if (String(this.kivalasztottOra?.szam_tema ?? '').trim()) return true;
    if (this.isMagatartasSzorgalomTantargy()) return true;
    if (this.temaKerdezve) return true;
    const mehet = confirm('A Téma mező üres, így a jegyek mellé nem kerül téma.\n\n'
      + 'Fél év múlva ebből nem lesz kideríthető, melyik dolgozatról volt szó.\n\n'
      + 'Így mentsem?');
    if (mehet) this.temaKerdezve = true;
    return mehet;
  }

  /*  MENTÉS KÖZBEN NINCS MÁSODIK KATTINTÁS. A mentés nem azonnali (a kiszolgáló a jegyeket
   *  egyenként írja és visszatölti a listát); közben a Mentés újranyomása ugyanazt a
   *  névsort MÁSODSZOR is elküldte – így lettek duplán a jegyek (Európa 2000, 2026-09-21).
   *  A várakozásjelző a képernyőt is lefedi, hogy közben ne lehessen máshová kattintani. */
  jegyMentesFolyamatban = false;

  async saveErtekeles() {
    if (this.jegyMentesFolyamatban) return;
    if (!this.temaRendben()) return;
    //this.ertekelesmodal.dismiss()
    const payloadOra = {
      ...this.kivalasztottOra,
      szam_tipus: this.kivalasztottOra?.szam_tipus ? String(this.kivalasztottOra.szam_tipus) : null,
      osztaly_nevsor: (this.kivalasztottOra?.osztaly_nevsor || []).map((tanulo: any) => {
        if (!this.isDualFokozatMode()) return { ...tanulo };

        return {
          ...tanulo,
          osztalyzat: this.getCombinedDualFokozat(tanulo),
        };
      }),
    };

    const beszamoloId = this.getBeszamoloTipusId();
    if (this.isMagatartasSzorgalomTantargy() && beszamoloId) {
      payloadOra.szam_tipus = beszamoloId;
    }

    console.log(payloadOra)
    this.jegyMentesFolyamatban = true;
    await this.datas.showLoading('Jegyek mentése…');
    this.http
      .post(
        '/api/ertekeles/mentes',
        { kivalasztottOra: payloadOra },
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.jegyMentesFolyamatban = false;
          try { this.datas.hideLoading() } catch (e) { }
          this.kivalasztottOra.osztaly_nevsor.forEach(k => {
            delete k.osztalyzat;
            delete k.szorgalomodost;
          });
  /*  A TÉMA NEM VÉSZ EL A MENTÉSSEL.
   *
   *  Eddig a sikeres mentés után a képernyő TÖRÖLTE a Téma mezőt. Egy dolgozat jegyeit
   *  viszont ritkán írja be valaki egy menetben: aki a névsor felét most, a másik felét
   *  öt perc múlva rögzíti, annál a második adag már téma NÉLKÜL ment el — csendben.
   *  A kolléga ebből azt látja, hogy „a rendszer nem menti a témát" (Európa 2000,
   *  2026-09-23, fizika és kémia), pedig a téma bement, csak a mező ürült ki közben.
   *
   *  Ezért a téma MARAD a mentés után: ugyanahhoz a dolgozathoz ugyanaz a téma való.
   *  A névsor értékei ürülnek (azok tanulónként mások), a téma nem. */
          /*  HA VALAKI KIMARADT, AZT MEG KELL MONDANI. Csoportos beírásnál a jegy a
           *  tanuló SAJÁT osztályához kerül – akinek nincs élő besorolása, annál nincs
           *  hova tenni. Egy néma kihagyás azt a látszatot keltené, hogy bement. */
          const kimaradt = (response as any)?.osztaly_nelkul_nevek || (response as any)?.osztaly_nelkul || [];
          const mentve = Number((response as any)?.mentve) || 0
          const mentveSzoveg = mentve === 1 ? "1 jegy mentve." : `${mentve} jegy mentve.`
          //  Egyéni munkarend: neki jegy csak osztályozó vizsgából adható – megnevezzük.
          const emNevek = (response as any)?.egyeni_munkarend_nevek || []
          /*  JEGYBEÍRÁSI HATÁRIDŐ (20/2012. EMMI r. 64. § (1a)): a jegy bement, de a jegy napjától
           *  számítva az iskola határidején túl. Nem hiba – csak egy mondat a visszajelzés végén. */
          const kesesMegj = (response as any)?.kesve?.uzenet ? ` ${(response as any).kesve.uzenet}` : ''
          if (emNevek.length && !kimaradt.length) {
            this.datas.sendToast(`${mentveSzoveg} Nem ment be: ${emNevek.slice(0, 5).join(', ')}${emNevek.length > 5 ? '…' : ''} – `
              + 'egyéni munkarendű, neki jegy csak osztályozó vizsgából adható.' + kesesMegj, "warning")
          } else if (kimaradt.length) {
            //  Egy üzenetben: két egymás utáni értesítés közül csak a második látszana.
            this.datas.sendToast(`${mentveSzoveg} Nem ment be: ${kimaradt.slice(0, 5).join(', ')}`
              + `${kimaradt.length > 5 ? '…' : ''} – nincs osztályba besorolva (az admin az Osztálybesorolásban pótolhatja).` + kesesMegj, "warning")
          } else {
            this.datas.sendToast(mentveSzoveg + kesesMegj, kesesMegj ? "warning" : "success")
          }
          this.ertekeles(null, this.kivalasztottOra, true)
        },
        error: (error) => {
          this.jegyMentesFolyamatban = false;
          try { this.datas.hideLoading() } catch (e) { }
          //  A kiszolgáló megmondja, mi a baj (pl. nincs beírt érték, eltérő osztályozási mód).
          this.datas.sendToast(error?.error?.error || "Hiba történt a mentéskor – a jegy nem ment be.", "error")
        },
      });
  }

  /* ── negyedéves és dicséretes jegy, módosítás ── */
  negyedevesE = negyedevesE;

  negyedevJel(item: any): string {
    return NEGYEDEV_JEL[String(item?.modja)] || '';
  }

  negyedevNev(item: any): string {
    return NEGYEDEV_NEV[String(item?.modja)] || '';
  }

  /** A jegy rövid alakja: záró/negyedéves érdemjegynél „5D”, „4”, „85%”, egyébként a szokásos. */
  jegyRovid(item: any): string {
    if (nemIrtaE(item)) return NEM_IRTA_JEL;
    return strukturaltRovid(item) ?? this.formatErtekelesRovid(item?.ertekeles);
  }

  /* ── „nem írta meg” (–) ──
   *  Jegy helyett mínusz annak, aki a dolgozatot nem írta meg (mint a KRÉTÁ-ban). Nem
   *  jegy: az átlagba nem számít, a KRÉTÁ-ba nem megy; amikor pótolta, a jegyre kattintva
   *  a „Jegy beírása” gombbal írható át. Csak osztályzat és százalék módban. */
  readonly NEM_IRTA_JEL = NEM_IRTA_JEL;
  nemIrtaE = nemIrtaE;

  /*  A JEGY RÉSZLETEI EGÉRRE IS (Hamvas-Fekete Anikó, 2026-10-12; user, 10-14): eddig csak
   *  kattintásra nyíló buborékban látszott, mi lett beírva. A ráállás most a böngésző súgójában
   *  mutatja ugyanezt; a kattintásra nyíló buborék a Módosítás / Törlés gombok miatt marad. */
  jegyHover(item: any): string {
    if (!item) return '';
    const sorok: string[] = [];
    if (this.nemIrtaE(item)) sorok.push('Nem írta meg');
    const special = this.getSpecialErtekelesReszletek(item.ertekeles);
    if (special) sorok.push(`Magatartás: ${special.magatartas}`, `Szorgalom: ${special.szorgalom}`);
    else if (String(item.ertekeles ?? '').length > 4) sorok.push(`Értékelés: ${item.ertekeles}`);
    if (item.tema) sorok.push(`Téma: ${item.tema}`);
    if (item.targynap) sorok.push(`Dátum: ${String(item.targynap).slice(0, 10)}`);
    const tipus = this.negyedevesE(item) ? this.negyedevNev(item) : (item.emnev || '');
    if (tipus) sorok.push(`Típus: ${tipus}`);
    if (item.szorzo !== undefined && item.szorzo !== null && item.szorzo !== '') sorok.push(`Súlyozás: ${item.szorzo}%`);
    const self: any = this;
    const tanar = typeof self.formatErtekelesTanar === 'function' ? self.formatErtekelesTanar(item)
      : (item.tanar_nev || item.tanarnev || item.tanar || '');
    if (tanar) sorok.push(`Tanár: ${tanar}`);
    if (item.modositva) sorok.push(`Módosítva: ${String(item.modositva).replace('T', ' ').slice(0, 16)}`);
    return sorok.join('\n');
  }
  nemIrtaJelE = nemIrtaJelE;

  get nemIrtaLehet(): boolean {
    return nemIrtaModE(this.kivalasztottOra?.osztalyozasimod);
  }

  /** A tanuló sorában a „–” gomb: be- és kikapcsolja a jelölést. */
  nemIrtaValt(tanulo: any) {
    if (!tanulo) return;
    tanulo.osztalyzat = nemIrtaJelE(tanulo.osztalyzat) ? '' : NEM_IRTA_JEL;
  }

  /** Egy beírt jegy módosítása helyben (érték, dátum, téma – a forma marad). */
  /** A saját kilétem azonosítói – ehhez mérjük, kié a jegy vagy a feljegyzés. */
  get enyemKulcsok(): string[] {
    return [this.userMetadata?.adid, this.userMetadata?.username, this.userMetadata?.email,
            this.user$?.preferred_username, this.user$?.username, this.user$?.email];
  }

  /** Az én tételem-e (jegy, feljegyzés)? Adminnál mindig igen. */
  sajatTetel(item: any): boolean {
    //  Az adminisztrátor a kollégáéhoz is hozzányúlhat – ugyanaz a mérce, mint a kiszolgálón.
    return sajatTetelE(item, this.enyemKulcsok, this.isRobotJelenletAdmin());
  }

  async modositJegy(item: any) {
    const adat = await jegyModositasBekeres(this.alertCtrl, item);
    if (!adat) return;
    await this.datas.showLoading('Módosítás...');
    this.http.post('/api/ertekeles/modositas', {
      ...adat,
      intezmeny: this.sajatIntezmeny?.intezmenyId,
    }).subscribe({
      next: (r: any) => {
        this.datas.hideLoading();
        this.datas.sendToast(r?.kreta_figyelmeztetes
          ? 'A jegy módosítva. Már a KRÉTÁ-ban is szerepel – a következő KRÉTA-szinkron ott is kijavítja.'
          : 'A jegy módosítva.', 'success');
        this.ertekeles(null, this.kivalasztottOra, true);
      },
      error: (e) => {
        this.datas.hideLoading();
        this.datas.sendToast(e?.error?.error || 'Nem sikerült módosítani a jegyet.', 'error');
      },
    });
  }

  /*  STORNO, NEM TÖRLÉS (user, 2026-10-15): a jegy áthúzva megmarad az Értékelések menüben,
   *  a napló képernyőjén eltűnik, és sehol nem számít. Az ok kötelező. */
  async torolJegy(item) {
    if (!item?.id) return;
    const ok = await stornoOkBekeres(this.alertCtrl, 'jegy');
    if (!ok) return;
    await this.datas.showLoading("Stornózás...")
    this.http
      .post(
        '/api/ertekeles/storno',
        { id: item.id, ok, intezmeny: this.sajatIntezmeny?.intezmenyId },
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.kivalasztottOra.osztaly_nevsor.forEach(k => {
            delete k.osztalyzat;
            delete k.szorgalomodost;
          });
          this.datas.hideLoading()
          /*  A KRÉTÁ-ban is törlődik – lásd az Értékelések képernyő azonos szabályát. */
          this.datas.sendToast((response as any)?.kreta_figyelmeztetes
            ? 'Stornózva. A jegy a KRÉTÁ-ban is szerepelt – a következő KRÉTA-szinkron ott törli.'
            : 'A jegy stornózva – az Értékelések menüben áthúzva látszik.', 'success')
          this.ertekeles(null, this.kivalasztottOra, true)
        },
        error: (error) => {
          try { this.datas.hideLoading() } catch (e) { }
          this.datas.sendToast(error?.error?.error || "Nem sikerült stornózni a jegyet.", "error")
        },
      });
  }

  getHolidays(returner = false): Observable<any> {
    //console.log('Access Token:', token);
    if (returner)
      return this.http
        .get(
          '/api/nyilvantartas/holidayallomany',
          {
            //headers: headers,
          }
        )
    else {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer `
      );
      this.http
        .get(
          '/api/nyilvantartas/holidayallomany',
          {
            //headers: headers,
          }
        )
        .subscribe({
          next: (response: any) => {
            this.holidays = Array.isArray(response) ? response : []

          },
          error: (error) => {
            console.error('Error fetching data:', error);

          },
        });
      return null;
    }


  }
  getMunkatarsakNew() {
    this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
    this.http
      .get(
        '/api/nyilvantartas/allomany/' + this.sajatIntezmeny.intezmenyId,//'https://idp.zenit.cronom.it/admin/realms/master/users?q=title:oktató',
        {}
      )
      .subscribe({
        next: (response: any) => {
          //console.log(response);

          response.forEach((element) => {
            element.user_id = element.id;
            element.name == element.viselt_vez + " " + element.viselt_ker
          });

          this.ports = response.sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0))
          this.ports.forEach((item: any) => {
            item.name = item.viselt_vez + " " + item.viselt_ker
          });
          this.portsDef = response.sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0))
          this.portsDef.forEach((item: any) => {
            item.name = item.viselt_vez + " " + item.viselt_ker
          });
          sessionStorage.setItem('allomany', JSON.stringify(this.ports))
          this.getHolidays()
          //this.getMeta()
          this.getData(this.selectedYear, this.selectedMonth);

        },
        error: (error) => {
          console.error('Error fetching data:', error);
          // Hiba esetén ne ragadjon fent a betöltés-spinner (idempotens dismiss).
          try { this.loading?.dismiss(); } catch (e) { }
        },
      });
  }

  refreshStatsPanel(year = this.selectedYear, month = this.selectedMonth) {
    this.http
      .post(
        '/api/szabadsag/' + year + '/' + this.sajatIntezmeny.intezmenyId,
        { honap: month }
      )
      .pipe(
        catchError((error) => {
          console.error('Error fetching szabadsag stats:', error);
          this.szabadsag = {};
          return of({});
        })
      )
      .subscribe({
        next: (response: any) => {
          this.szabadsag = response || {}
          this.recomputeStatistics()
        }
      })
    this.http
      .get(
        '/api/utazas/' + year + '/' + month + '/' + this.sajatIntezmeny.intezmenyId,

      )
      .pipe(
        catchError((error) => {
          console.error('Error fetching utazas stats:', error);
          this.utazas = {};
          return of({});
        })
      )
      .subscribe({
        next: (response: any) => {
          this.utazas = response || {}
          this.recomputeStatistics()
        }
      })
  }
  /* ══════════════════════════════════════════════════════════════════════
   *  KÉSÉS
   *
   *  A névsorban percben rögzítjük, ki mennyit késett. A percek a `keses` táblába
   *  kerülnek, és a rendszer SZÁMOLJA belőlük az órákat: 45 összegyűlt igazolatlan
   *  perc = 1 igazolatlan óra (20/2012. EMMI 51. §). Azért nem könyveljük el az órát
   *  külön rekordként, mert egy utólagos igazolás így magától átsorolja – nem kell
   *  visszakeresni és javítani egy korábban létrehozott mulasztást.
   * ═════════════════════════════════════════════════════════════════════ */

  /** oraId → { oktazon → { perc, igazolt, indok } } */
  kesesek: any = {};
  kesesMentesFut = false;

  async kesesekBetolt(orak: any[]) {
    const idk = (orak || []).map((o) => o?.id).filter(Boolean);
    if (!idk.length) { this.kesesek = {}; return; }
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/keses/orak/${this.sajatIntezmeny.intezmenyId}?idk=${idk.join(',')}`));
      this.kesesek = r?.orak || {};
    } catch { this.kesesek = {}; }
  }

  kesesPerc(o: any, n: any): number | null {
    const p = this.kesesek?.[o?.id]?.[n?.oktazon]?.perc;
    return p ? Number(p) : null;
  }

  /** Igazolt késésnél a mezőt jelöljük – a tanár lássa, hogy már el van bírálva. */
  kesesIgazolt(o: any, n: any): boolean {
    return !!this.kesesek?.[o?.id]?.[n?.oktazon]?.igazolt;
  }

  /**
   *  ÓRALÁTOGATÁS ALÓL FELMENTVE ezen az órán?
   *
   *  A szerver mondja meg (nevsor-jelzesek.js), és csak szerkezetes felmentésből –
   *  KRÉTA-nyilvántartás vagy a saját rögzítés –, sosem egy határozat szövegéből.
   *  Következménye van: a sor kiszürkül, és a tanulót nem lehet hiányzónak beírni,
   *  mert aki fel van mentve az óra látogatása alól, annak a távolléte nem mulasztás.
   */
  oralatogatasAlol(o: any, n: any): boolean {
    return !!o?.nevsor_jelzesek?.[n?.oktazon]?.oralatogatas_alol;
  }

  /**
   *  KERESÉS A NÉVSORBAN (#1097). Egy 30-35 fős csoportban a tanuló megkeresése görgetés volt.
   *  A szűrő CSAK ELREJT, nem szűri a tömböt: a névsor sorait index szerint is címezzük
   *  (értékelés, jegygombok), egy szűrt tömb rossz tanulóhoz írná a jegyet. Név (ékezet és
   *  kis-/nagybetű nélkül, bármelyik részlete) vagy oktatási azonosító szerint keres.
   */
  ertekelesNevSzuro = '';
  nevsorEgyezik(szuro: string | null | undefined, n: any): boolean {
    const s = this.nevNormal(szuro);
    if (!s) return true;
    return this.nevNormal(n?.nev).includes(s) || String(n?.oktazon ?? '').includes(s);
  }
  nevsorTalalat(szuro: string | null | undefined, nevsor: any[] | null | undefined): number {
    return (nevsor || []).filter((n) => this.nevsorEgyezik(szuro, n)).length;
  }
  private nevNormal(v: any): string {
    return String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /**
   *  A TANTÁRGYI MULASZTÁS ARÁNYA a névsorban (20/2012. EMMI r. 51. § (7) f): a tanórák 30%-át
   *  meghaladó mulasztásnál a tanuló nem minősíthető). A szerver számolja, az óra összes
   *  tanulójára egyszerre (backend/mulasztas-arany.js – ugyanaz, mint az osztályfőnöki
   *  Minősíthetőség nézeté és a bizonyítványé); itt csak a jelvény és a súgó szövege.
   *  szint: rendben (< 20%) · sarga (20–25%) · narancs (25–30%) · piros (≥ 30%) · keves (kevés óra).
   */
  mulasztasArany(o: any, n: any): { megtartott: number; mulasztott: number; igazolatlan: number;
    tervezett: number; szazalek: number; szint: string } | null {
    return o?.mulasztas_arany?.[n?.oktazon] || null;
  }

  mulasztasAranyCim(a: { megtartott: number; mulasztott: number; igazolatlan: number;
    tervezett: number; szazalek: number; szint: string } | null): string {
    if (!a) return '';
    const sorok = [`${a.mulasztott}/${a.megtartott} óra mulasztás ebből a tantárgyból (${a.szazalek}%) – `
      + 'a 30%-os határ: 20/2012. EMMI r. 51. § (7)'];
    if (a.igazolatlan) sorok.push(`Ebből igazolatlan: ${a.igazolatlan} óra`);
    if (a.tervezett > a.megtartott) {
      sorok.push(`A tanév ${a.tervezett} órarendi órájának 30%-a: ${Math.floor(a.tervezett * 0.3)} óra`);
    }
    if (a.szint === 'keves') sorok.push('Még kevés a megtartott óra – a színjelzés 10 órától számít');
    if (a.szint === 'piros') sorok.push('Elérte a 30%-ot: e fölött a tanuló nem minősíthető, osztályozó vizsga kell');
    return sorok.join('\n');
  }

  /**
   *  A mező elhagyásakor mentünk. A szerver a TELJES óra-állapotot várja, ezért a
   *  többi tanuló percét is elküldjük – így egy kiürített mező tényleg törli a késést,
   *  nem hagy árva sort.
   */
  async kesesValt(o: any, n: any, ertek: any) {
    /*  Csak a számjegyek számítanak: a mező szöveges (lásd a sablonnál, miért), tehát
     *  egy odakerült szóköz vagy betű ne tegye érvénytelenné az egész beírást.
     *  A felső határ 600 perc – ennél hosszabb késés már hiányzás, és egy elgépelt
     *  nullával sem lehet tízórás késést rögzíteni. */
    //  A mínuszjelet MEGHAGYJUK, hogy a „-3" érvénytelen maradjon (0), ne 3 legyen belőle.
    const perc = Number(String(ertek ?? '').replace(',', '.').replace(/[^\d.-]/g, ''));
    const ervenyes = Number.isFinite(perc) && perc > 0 ? Math.min(600, Math.round(perc)) : 0;

    if (!this.kesesek[o.id]) this.kesesek[o.id] = {};
    if (ervenyes) {
      this.kesesek[o.id][n.oktazon] = { ...(this.kesesek[o.id][n.oktazon] || {}), perc: ervenyes };
    } else {
      delete this.kesesek[o.id][n.oktazon];
    }

    const tetelek = Object.entries(this.kesesek[o.id] || {})
      .map(([oktazon, v]: any) => ({ oktazon, perc: Number(v?.perc) || 0 }))
      .filter((t) => t.perc > 0);

    this.kesesMentesFut = true;
    try {
      await firstValueFrom(this.http.post('/api/keses/ora', {
        intezmeny: this.sajatIntezmeny.intezmenyId,
        // Tokenes hitelesítés nélkül (dev, standalone) ebből tudja a szerver, ki rögzítette.
        rogzitette: this.userMetadata?.adid || null,
        ora: o.id,
        datum: o.datum,
        oraszam: o.ora,
        //  AZONOSÍTÓT küldünk, nem nevet: az `osztaly` mező a napló válaszában az
        //  osztály NEVE („12/B"), az azonosító az `osztalyid`. A késés táblája uuid-t
        //  vár, névvel a mentés hibára futott.
        osztaly: o.osztalyid || null,
        tetelek,
      }));
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'A késés mentése nem sikerült.', 'error');
      await this.kesesekBetolt(this.napiOrarend);
    } finally {
      this.kesesMentesFut = false;
    }
  }

  datumNap(d1, d2) {
    let now = moment(d2); //todays date
    let end = moment(d1); // another date
    let duration = moment.duration(now.diff(end));
    let h = duration.asDays();
    return h
  }
  selectChanged(e) {
    //console.log(e)
    // Ha közben a hónap/év is változott, a munkatárs-váltás már az új időszakot tölti be.
    this.idoszakRogzit();
    if (e[0]) {
      this.uuid = e[0].adid;
      this.sajatnev = e[0].viselt_vez + " " + e[0].viselt_ker
      this.userMetadata.auth0id = e[0].auth0id
      this.daysInMonth = [];
      this.showLoading('Adatok lekérése...');
      this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
      this.getData(this.selectedYear, this.selectedMonth);
    }
    else if (e == "saját") {
      this.daysInMonth = [];
      // Extract the user_metadata claim from the ID token
      this.uuid = this.user$.username;
      //this.port = { id: this.user$.attributes.company.toString(), name: this.user$.attributes.company.toString() };
      //console.log(idTokenClaims['https://claims.vszc/uuid']);
      this.showLoading('Adatok betöltése...').then(() => {
        this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
        this.getData(this.selectedYear, this.selectedMonth);
      });


    }
  }
  selectChangedIntezmeny(e) {
    this.showLoading('Adatok lekérése...');
    //console.log(e)
    //console.log(this.ports)
    this.ports = this.portsDef.filter(d => {
      for (let i = 0; i < d.intezmenyadatok.length; i++) {
        if (d.intezmenyadatok[i].intezmenyId == e[0].intezmenyId) {
          return true;

        }
      }
      return false;
    }).sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
    this.sajatIntezmeny = e[0]
    this.refreshStatsPanel(this.selectedYear, this.selectedMonth)
    this.getData(this.selectedYear, this.selectedMonth);

  }
  weeksInYear(year) {
    var month = 11,
      day = 31,
      week;

    // Find week that 31 Dec is in. If is first week, reduce date until
    // get previous week.
    let d;
    do {
      d = new Date(year, month, day--);
      week = this.getWeekNumber(d)[1];
    } while (week == 1);

    return week;
  }
  async showLoading(msg) {
    // Egymásra futó betöltésnél az előző jelző ne ragadjon a képernyőn.
    try { this.loading?.dismiss(); } catch (e) { }
    this.loading = await this.loadingCtrl.create({
      message: msg,
    });

    this.loading.present();
  }

  async getMeta() {
    //let u = await this.auth.user$.pipe(take(1)).toPromise();


    if (this.user$) {
      this.ports.forEach((item: any) => {
        item.name = item.viselt_vez + " " + item.viselt_ker
      })
      // Extract the user_metadata claim from the ID token
      this.userMetadata = this.user$.attributes;
      if (!this.ports.filter((item: any) => item.adid == this.user$.attributes.company)[0])
        this.userMetadata["data"] = this.ports.filter((item: any) => item.adid == this.user$.username)[0];
      else
        this.userMetadata["data"] = this.ports.filter((item: any) => item.adid == this.user$.attributes.company)[0];


      console.log(this.userMetadata);

    } else {
    }
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  async delete() {

    if (this.napiOrarend) {
      let akttev = JSON.parse(await this.datas.getFromStorage("tanev")).aktualistanev
      let tanev = JSON.parse(await this.datas.getFromStorage("tanevadatok")).filter(d => d.id == akttev)[0];
      let tankezd = moment(tanev.tankezd).format("YYYY-MM-DD")
      this.napiOrarend.forEach(h => {
        h.konyvelte = null;
        h.konyvelve = null;
        h.tema = null;
        h.hianyzo = []
        h.hazihiany = []
        h.felszhiany = []
        h.felmentes = []
        h.dicseret = []

      });
      this.http
        .post(
          '/api/orarend/bulkkonyvel/' + this.sajatIntezmeny.intezmenyId,
          {
            data: this.buildOrarendMentendoTomb(this.napiOrarend)
          }
        ).subscribe({
          next: (response: any) => {
            console.log(response)
            this.napiOrarend = null
          }
        })
    }

    //console.log('Access Token:', token);
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    const body = {};
    this.http
      .post(
        '/api/nyilvantartas/' +
        this.uuid +
        '/delete/' +
        this.currentday.nyilvantartas.uuid,
        body,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          //console.log(response);
          this.getData(this.selectedYear, this.selectedMonth);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });

  }
  isHoliday(date, holidays) {
    // Check if the date is a holiday
    let time = date.setHours(0, 0, 0, 0);
    //console.log(time)
    //console.log(holidays)
    return holidays.includes(time);
    /*return holidays.some(holiday =>
      date.getFullYear() === holiday.getFullYear() &&
      date.getMonth() === holiday.getMonth() &&
      date.getDate() === holiday.getDate()
    );*/
  }
  tomegesRekord() {
    let workingDays = [];
    let currentDate = new Date(this.kezdodatum);
    let endDate = new Date(this.vegsodatum);
    //let round = Math.round((new Date(this.vegsodatum).getTime()-(new Date(this.kezdodatum).getTime())) / (1000 * 3600 * 24))+1 
    let holidays = this.holidays.map(holiday => new Date(holiday.date).setHours(0, 0, 0, 0));
    //console.log(holidays)
    while (currentDate <= endDate) {
      //console.log(currentDate)
      let dayOfWeek = currentDate.getDay();

      // Check if it's not a weekend and not a holiday
      if (dayOfWeek !== 0 && dayOfWeek !== 6 && !this.isHoliday(currentDate, holidays)) {
        workingDays.push(new Date(currentDate)); // Add the date to the workingDays array
      }

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }
    this.bulkProcess = true;
    this.showLoading('Tömeges mentés...');
    workingDays.forEach(day => {
      this.selectedYear = new Date(day).getFullYear();
      this.selectedMonth = new Date(day).getMonth() + 1;
      this.currentday = {};
      this.currentday.dayNumber = new Date(day).getDate();
      this.confirm()
    })
    //this.bulkProcess = false;
    window.location.reload();
  }
  async confirm() {
    /*  A TÉMA NÉLKÜLI ÓRÁRÓL NEM KÉRDEZÜNK MENTÉSKOR. Korábban egy ablak sorolta fel
     *  (2026-09-17), de félrevezetett: múltbeli napon a le sem nyitott órára is szólt, a
     *  kolléga pedig a nyitott, témás órára értette („ott a téma, mégis kéri", 2026-09-28).
     *  A könyvelés állapotát az óra színe és a címsor melletti számláló („könyvelve: x / y")
     *  mutatja, az órán belül pedig a téma nélküli óra saját jelzést kap. */
    //this.loader.present();
    if (!this.bulkProcess && !this.napiOrarend) this.showLoading('Mentés...');
    if (!this.bulkProcess && this.napiOrarend) this.showLoading('Mentés és naplózás...');
    this.modal.dismiss(null, 'confirm');
    if (!this.bulkProcess && this.napiOrarend) {
      let akttev = JSON.parse(await this.datas.getFromStorage("tanev")).aktualistanev
      let tanev = JSON.parse(await this.datas.getFromStorage("tanevadatok")).filter(d => d.id == akttev)[0];
      let tankezd = moment(tanev.tankezd).format("YYYY-MM-DD")
      this.http
        .post(
          '/api/orarend/bulkkonyvel/' + this.sajatIntezmeny.intezmenyId,
          {
            data: this.buildOrarendMentendoTomb(this.napiOrarend, true)
          }
        ).subscribe({
          next: (response: any) => {
            console.log(response)
            this.napiOrarend = null
          },
          //  A napló mentésének hibája sem maradhat néma: az ablak már bezárult, a
          //  kolléga különben azt hinné, minden rendben van. A lezárt napot (409) a kiszolgáló
          //  szövegével írjuk ki: az mondja meg, miért és hogyan oldható fel.
          error: (e: any) => {
            console.error('Napló mentési hiba:', e);
            this.datas.sendToast(e?.status === 409 && e?.error?.error
              ? e.error.error
              : 'Az órák mentése nem sikerült – nyisd meg újra a napot, és próbáld újra.', 'error');
          }
        })
    }
    if (!this.currentday.nyilvantartas) {

      //console.log('Access Token:', token);
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer `
      );
      const body = {
        user: this.uuid,
        erko: this.erko,
        erkp: this.erkp,
        tavo: this.tavo,
        tavp: this.tavp,
        c1: this.c1,
        c2: this.c2,
        c3: this.c3,
        jelenlet: this.jelenlet,
        year: this.selectedYear,
        month: this.selectedMonth,
        day: this.currentday.dayNumber,
        intezmeny: this.sajatIntezmeny.om,
        feladatellatas: this.sajatIntezmeny.intezmenyId
      };
      this.http
        .post('/api/nyilvantartas/' + this.uuid, body, {
          // headers: headers,
        })
        .subscribe({
          next: (response) => {
            //console.log(response);
            if (!this.bulkProcess) this.getData(this.selectedYear, this.selectedMonth);
          },
          error: (error) => {
            console.error('Error fetching data:', error);
            // Siker esetén a getData zárja a spinnert; hiba esetén itt kell (idempotens).
            try { this.loading?.dismiss(); } catch (e) { }
          },
        });

    } else {
      if (!this.bulkProcess) {

        //console.log('Access Token:', token);
        const headers = new HttpHeaders().set(
          'Authorization',
          `Bearer `
        );
        const body = {
          user: this.uuid,
          erko: this.erko,
          erkp: this.erkp,
          tavo: this.tavo,
          tavp: this.tavp,
          c1: this.c1,
          c2: this.c2,
          c3: this.c3,
          jelenlet: this.jelenlet,
          year: this.selectedYear,
          month: this.selectedMonth,
          day: this.currentday.dayNumber,
          intezmeny: this.sajatIntezmeny.om,
          feladatellatas: this.sajatIntezmeny.intezmenyId

        };
        this.http
          .post(
            '/api/nyilvantartas/' +
            this.uuid +
            '/update/' +
            this.currentday.nyilvantartas.uuid,
            body,
            {
              //headers: headers,
            }
          )
          .subscribe({
            next: (response) => {
              //console.log(response);
              this.getData(this.selectedYear, this.selectedMonth);
            },
            error: (error) => {
              console.error('Error fetching data:', error);
              // Siker esetén a getData zárja a spinnert; hiba esetén itt kell (idempotens).
              try { this.loading?.dismiss(); } catch (e) { }
            },
          });
      }
    }
  }

  deleteRecord() { }

  /* ── Utólagos helyettesítés bejelentése a naplóból ──────────────────── */

  /** A kapcsoló intézményenként áll; ha nincs bekapcsolva, a blokk meg sem jelenik. */
  private async helyBeallitasBetolt() {
    try {
      const r: any = await firstValueFrom(this.http.get(
        '/api/helyettesites-bejelentes/beallitas/' + this.sajatIntezmeny.intezmenyId));
      this.helyBe = !!r?.bekapcsolva;
    } catch (e) { this.helyBe = false; }
  }

  /** A naplóban éppen nyitva lévő nap, a szerver által várt alakban. */
  helyNap(): string {
    return this.currentday?.dayDate ? moment(this.currentday.dayDate).format('YYYY-MM-DD') : '';
  }

  /** Jövőbeli órát nem lehet megtartottként bejelenteni – a szerver is ezt mondja. */
  helyJovobeli(): boolean {
    const nap = this.helyNap();
    return !!nap && nap > moment().format('YYYY-MM-DD');
  }

  helyMegnyit() {
    this.helyNyitva = true;
    this.helyValasztott = null;
    this.helyIndok = '';
    this.helyOraSzam = null;
    this.helyOrakBetolt();
  }

  helyBezar() {
    this.helyNyitva = false;
    this.helyOrak = null;
    this.helyValasztott = null;
    this.helyIndok = '';
  }

  /*  A nap órái, amelyekre bejelentés tehető. A szűrést a SZERVER végzi: a saját órák
   *  és a jövő eleve nem jönnek vissza – nem a felület dönti el, mi jelenthető be.
   */
  async helyOrakBetolt() {
    const nap = this.helyNap();
    if (!nap) return;
    this.helyFut = true;
    this.helyOrak = null;
    try {
      const p = new URLSearchParams({ datum: nap, allomany: this.uuid });
      /*  HÁNYADIK ÓRA – nem kötelező. Egy napon húsz-harminc óra is lehet a listában;
       *  ha a kolléga tudja, melyik órát tartotta, ne kelljen az egészet átnéznie.
       *  A szűrést itt is a KISZOLGÁLÓ végzi – a felület csak kéri. */
      if (this.helyOraSzam) p.set('ora', String(this.helyOraSzam));
      this.helyOrak = await firstValueFrom(this.http.get<any[]>(
        '/api/helyettesites-bejelentes/orak/' + this.sajatIntezmeny.intezmenyId
        + '?' + p.toString())) || [];
    } catch (e: any) {
      this.helyOrak = [];
      this.datas.sendToast(e?.error?.error || 'Az órák lekérése nem sikerült.', 'error');
    } finally {
      this.helyFut = false;
    }
  }

  helyOraCim(o: any): string {
    const hol = o?.csoport_nev || o?.osztaly_nev || '';
    return `${o?.ora}. óra – ${hol}${o?.tantargy_nev ? ' · ' + o.tantargy_nev : ''}`;
  }

  /** Már be van jelentve (bárki által) – ilyenkor a sor nem választható. */
  helyMarBejelentve(o: any): boolean {
    return !!o?.bejelentes_id;
  }

  helyValaszt(o: any) {
    if (this.helyMarBejelentve(o)) return;
    this.helyValasztott = this.helyValasztott?.id === o?.id ? null : o;
  }

  async helyBejelent() {
    if (!this.helyValasztott) {
      this.datas.sendToast('Válaszd ki az órát.', 'warning');
      return;
    }
    this.helyKuld = true;
    try {
      await firstValueFrom(this.http.post('/api/helyettesites-bejelentes/bejelentes', {
        intezmeny: this.sajatIntezmeny.intezmenyId,
        ora: this.helyValasztott.id,
        bejelento: this.uuid,
        tipus: this.helyTipus,
        mod: this.helyMod,
        indok: this.helyIndok || null,
      }));
      this.datas.sendToast('Bejelentve. Az adminisztrátor jóváhagyásáig az órarend nem változik.', 'success');
      this.helyValasztott = null;
      this.helyIndok = '';
      await this.helyOrakBetolt();
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'A bejelentés nem sikerült.', 'error');
    } finally {
      this.helyKuld = false;
    }
  }

  /** A saját óra elmaradt (táppénz, senki nem helyettesítette): az adathiba-modul jelöli,
   *  naplózva és visszavonhatóan – ugyanaz a szabály, mint az „Elmaradtak az óráim” pontban. */
  /*  ELMARADT – önálló állapot, nem helyettesítési mód (2026-10-15). A kiszolgáló naplózza (ki,
   *  mikor, miért), és visszautasítja a beírt, a helyettesített és a lezárt napra eső órát. */
  async oraElmaradt(ev: Event, o: any) {
    ev?.stopPropagation?.();
    const ok = prompt(`Elmaradt ez az óra (${o.ora}. óra – ${o.tantargy || ''})? Nem számít majd könyveletlennek.\n\nAz elmaradás oka (pl. táppénz, kirándulás):`, '');
    if (ok === null) return;
    try {
      await firstValueFrom(this.http.post('/api/ora-naplo/elmaradt/' + this.sajatIntezmeny?.intezmenyId,
        { ora_id: o.id, elmaradt: true, ok: ok.trim() || null }));
      this.datas.sendToast('Az óra elmaradtként jelölve.', 'success');
      o.elmaradt = 1; o.elmaradt_ok = ok.trim() || null;
      this.getData(this.selectedYear, this.selectedMonth);
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'Nem sikerült jelölni.', 'error');
    }
  }

  async oraElmaradtVissza(ev: Event, o: any) {
    ev?.stopPropagation?.();
    if (!confirm(`Mégis megtartották ezt az órát (${o.ora}. óra – ${o.tantargy || ''})? Az elmaradt jelölés lekerül.`)) return;
    try {
      await firstValueFrom(this.http.post('/api/ora-naplo/elmaradt/' + this.sajatIntezmeny?.intezmenyId,
        { ora_id: o.id, elmaradt: false }));
      this.datas.sendToast('Az elmaradt jelölés visszavonva.', 'success');
      o.elmaradt = null; o.elmaradt_ok = null;
      this.getData(this.selectedYear, this.selectedMonth);
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'Nem sikerült visszavonni.', 'error');
    }
  }

  /** Az óra előzménye (beírás, javítások, törlés) egy ablakban. */
  async elozmenyek(ev: Event, o: any) {
    ev?.stopPropagation?.();
    this.elozmenyOra = o;
    this.elozmenyAdat = null;
    this.elozmenyBetolt = true;
    this.elozmenymodal?.present();
    try {
      this.elozmenyAdat = await firstValueFrom(this.http.get('/api/ora-naplo/elozmeny/' + o.id));
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'Az előzmény nem tölthető be.', 'error');
    } finally {
      this.elozmenyBetolt = false;
    }
  }

  elozmenyMezok(b: any): string[] {
    return Object.keys(b?.utana || b?.elotte || {});
  }

  /** Egy naplózott érték olvashatóan: a listák (hiányzók stb.) a névsorból névvel. */
  elozmenyErtek(mezo: string, v: any): string {
    if (v === null || v === undefined || v === '') return '–';
    if (Array.isArray(v)) {
      if (!v.length) return '–';
      const nevsor = this.elozmenyOra?.osztaly_nevsor || [];
      return v.map((x: any) => {
        const [okt, tipus] = mezo === 'igazolas' ? String(x).split(':') : [String(x), ''];
        const t = nevsor.find((n: any) => String(n.oktazon) === okt);
        const nev = t ? `${t.viselt_vez || ''} ${t.viselt_ker || ''}`.trim() : okt;
        return tipus ? `${nev} (${this.IGAZOLAS_TIPUS_NEV[tipus] || tipus})` : nev;
      }).join(', ');
    }
    if (mezo === 'elmaradt' || mezo === 'helyettesites') return Number(v) ? 'igen' : 'nem';
    if (mezo === 'konyvelte' || mezo === 'helyettesito') {
      const a: any = (this.ports || []).find((p: any) => p.adid === v);
      return a ? `${a.viselt_vez || ''} ${a.viselt_ker || ''}`.trim() : String(v);
    }
    return typeof v === 'object' ? JSON.stringify(v) : String(v);
  }

  helyTipusNev(e: string) { return this.HELY_TIPUSOK.find((x) => x.e === e)?.n || e; }
  helyModNev(e: string) { return this.HELY_MODOK.find((x) => x.e === e)?.n || e; }

  onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
    }
  }

  /** A napi ablak napja 'ÉÉÉÉ-HH-NN' alakban (a beágyazott fogadóórának). */
  get modalNap(): string {
    const k = (n: any) => String(n).padStart(2, '0');
    return `${this.selectedYear}-${k(this.selectedMonth)}-${k(this.selectedDay)}`;
  }

  async initModal(day, d = 0, elore = false) { //console.log(day)
    this.tomeges = false;
    this.helyBezar();
    this.elore = elore;
    this.erko = day.nyilvantartas?.start
      ? new Date(day.nyilvantartas.start).getUTCHours().toString()
      : '';
    this.erkp = day.nyilvantartas?.start
      ? new Date(day.nyilvantartas.start).getUTCMinutes().toString()
      : '';
    this.tavo = day.nyilvantartas?.end
      ? new Date(day.nyilvantartas.end).getUTCHours().toString()
      : '';
    this.tavp = day.nyilvantartas?.end
      ? new Date(day.nyilvantartas.end).getUTCMinutes().toString()
      : '';
    this.selectedDay = day.dayNumber;
    this.c1 = day.nyilvantartas?.c1 ? day.nyilvantartas.c1 : 0;
    this.c2 = day.nyilvantartas?.c2 ? day.nyilvantartas.c2 : 0;
    this.c3 = day.nyilvantartas?.c3 ? day.nyilvantartas.c3 : 0;
    this.helyettes = 0 //day.nyilvantartas?.helyettesites ? day.nyilvantartas.helyettesites : 0;
    this.tartoshely = 0 //day.nyilvantartas?.tartos ? day.nyilvantartas.tartos : 0;
    this.szivhely = 0
    this.currentday = day;
    this.jelenlet = day.nyilvantartas?.status ? day.nyilvantartas.status : (elore ? 2 : 1);

    this.http
      .get(
        '/api/ertekeles/tipusok',
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          //this.holidays = response
          this.ertekelesTipus = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });

    //  Lezárt naplóidőszak? (naplo-zaras.js) – a tiltás a kiszolgálón van, itt csak kiírjuk.
    this.napLezart = null;
    {
      const nap = moment(day.dayDate).format("YYYY-MM-DD");
      this.http.get<any>(`/api/naplo-zaras/allapot/${this.sajatIntezmeny.intezmenyId}?tol=${nap}&ig=${nap}`).subscribe({
        next: (r) => { this.napLezart = r?.lezart?.[nap]?.ok || null; },
        error: () => { this.napLezart = null; },
      });
    }
    this.http
      .get(
        '/api/orarend/nap/' +
        moment(day.dayDate).format("YYYY-MM-DD") +
        '/' +
        this.uuid + '/' + this.sajatIntezmeny.intezmenyId,
        {}
      )
      .subscribe({
        next: (response: any) => {
          const safeArr = (v) => {
            if (Array.isArray(v)) return v
            try { const p = JSON.parse(v); return Array.isArray(p) ? p : [] } catch { return [] }
          }
          response.forEach(g => {
            if (g.osztaly_nevsor) g.osztaly_nevsor = safeArr(g.osztaly_nevsor).sort((a, b) => a.viselt_vez.localeCompare(b.viselt_vez, 'hu'))
            g.hianyzo = safeArr(g.hianyzo)
            g.hazihiany = safeArr(g.hazihiany)
            g.felszhiany = safeArr(g.felszhiany)
            g.felmentes = safeArr(g.felmentes)
            g.dicseret = safeArr(g.dicseret)
            g.jelenvolt = safeArr(g.jelenvolt)
            this.jelolesekIgazitasa(g)
            // Opcionális részvétel (nem tanórai célú csoport): üres alap-státusz, csak jelenlét jelölés.
            g.opcionalis = Number(g.opcionalis_reszvetel) === 1
            //  Csoportos óra: a tanulók osztályonkénti megoszlása (a kiszolgáló a névsor minden
            //  tanulójához az osztályát is adja – backend/csoport-nevsor.js).
            g.megoszlasSzoveg = this.megoszlasSzoveg(g.osztaly_megoszlas)
            g.tobbOsztaly = Array.isArray(g.osztaly_megoszlas) && g.osztaly_megoszlas.length > 1
            g.tema = g.rogzitett_tema ?? g.ajanlott_tema ?? null
            g.temaAutomatikus = !g.rogzitett_tema && !!g.ajanlott_tema
            g.temaModositott = false
            g.temaEredeti = g.tema
            //  Minden nap tiszta lappal indul: a tegnapi kinyitás ma nem számít.
            g.megnyitva = false
            g.eredetilegLekonyvelt = !!(g.konyvelte && String(g.rogzitett_tema || '').trim())
            if (g.helyettesites_tipus == "E") this.helyettes++
            if (g.helyettesites_tipus == "T") this.tartoshely++
            if (g.helyettesites_tipus == "S") this.szivhely++
            this.helyettes += this.tartoshely + this.szivhely
          });
          this.napiOrarend = response
          this.kesesekBetolt(response)
          this.digitalisMunkarendBetolt(moment(day.dayDate).format("YYYY-MM-DD"))
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
    //console.log(day.nyilvantartas?.status);
    //this.ref.detectChanges();
    if (d == 0) await this.modal.present();
    if (d == 1) await this.al.present();
    //this.ref.detectChanges();
  }
  /*  TANTERMEN KÍVÜLI, DIGITÁLIS MUNKAREND (backend: digitalis-munkarend.js) – CSAK JELÖLÉS.
   *  A nap elrendelt időszakai a feloldott osztályokkal és csoportokkal; az óra fejléce és a tartalma
   *  ebből jelöl. Az óra mentéséhez és a mulasztás számításához nem nyúl: a jelenlét ilyenkor az
   *  online részvétel, a távolmaradó tanulót a szokásos módon kell hiányzónak jelölni. */
  dmIdoszakok: any[] = [];

  digitalisMunkarendBetolt(datum: string) {
    this.dmIdoszakok = [];
    const int = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    if (!int || !/^\d{4}-\d{2}-\d{2}$/.test(datum)) return;
    this.http.get<any[]>(`/api/digitalis-munkarend/aktiv/${encodeURI(int)}?tol=${datum}&ig=${datum}`).subscribe({
      next: (r) => { this.dmIdoszakok = Array.isArray(r) ? r : []; },
      error: () => { this.dmIdoszakok = []; },
    });
  }

  /** Az óra digitális munkarendben van-e: az osztálya, vagy (csoportos órán) a csoport valamelyik osztálya érintett. */
  dmOra(o: any): any {
    if (!o || !this.dmIdoszakok?.length) return null;
    const oszt = String(o.osztalyid || ''); const csop = String(o.csoport || '');
    return this.dmIdoszakok.find((x: any) =>
      (oszt && (x.osztalyok || []).some((y: any) => String(y.id) === oszt))
      || (csop && (x.csoportok || []).map(String).includes(csop))) || null;
  }

  async initTomeges() {
    this.tomeges = true;
    await this.modal.present();
  }

  /*  MELYIK ÓRÁT NYITOTTA KI A KOLLÉGA?
   *
   *  Az `ion-accordion-group` a NYITVA lévő elemek azonosítóit adja vissza. A becsukás
   *  nem vonja vissza a jelölést: aki egyszer kinyitotta az órát, az látta – a
   *  „megnyitottam, aztán becsuktam" nem lehet kibúvó a naplózás alól. */
  oraMegnyitva(esemeny: any) {
    const ertek = esemeny?.detail?.value;
    const idk = Array.isArray(ertek) ? ertek : (ertek ? [ertek] : []);
    for (const id of idk) {
      const ora = (this.napiOrarend || []).find(o => o?.id === id);
      if (ora) ora.megnyitva = true;
    }
  }

  /*  MI SZÁMÍT A KOLLÉGA MUNKÁJÁNAK?
   *
   *  A tanmenet MINDEN órához felkínál egy témát – ez segítség, nem beírás. Ha mentéskor
   *  ezt is beírnánk és lekönyvelnénk, akkor egyetlen óra kitöltése után az egész nap
   *  „naplózottnak" látszana, holott a kolléga a többi órát meg sem nyitotta. Rosszabb:
   *  a beírt javaslat a következő betöltéskor már RÖGZÍTETT témának látszana, tehát a
   *  tévedés maradandóvá válna – pontosan ez történt eddig.
   *
   *  Ezért csak az az óra könyvelhető, amivel a kolléga ténylegesen foglalkozott:
   *  volt már rajta mentett téma, most átírta a témát, vagy kinyitotta az órát. */
  private oraErintve(ora: any): boolean {
    if (this.normalizaltTema(ora?.rogzitett_tema)) return true;
    if (ora?.temaModositott) return true;
    return !!ora?.megnyitva;
  }

  /*  TÉMA NÉLKÜLI ÓRA.
   *
   *  A más által tartott (helyettesített) saját óra témáját nem a kolléga írja – azt
   *  kihagyjuk. */
  temaHianyzik(ora: any): boolean {
    if (!ora || (ora.tanar == this.uuid && ora.helyettesites)) return false;
    return !this.normalizaltTema(ora.tema);
  }

  /*  HÁNY ÓRA SZÁMÍT KÖNYVELTNEK A NAPBÓL? A címsor mellett áll, hogy mentés után
   *  egy pillantásra látszódjon, mi maradt piros. A más által tartott (helyettesített)
   *  saját óra nem a kolléga könyvelése – az a számlálóból kimarad. */
  get konyveltSzamlalo(): { konyvelt: number; osszes: number } {
    //  Az elmaradt óra (orarendv2.elmaradt) nem vár könyvelésre – ahogy a helyettesített saját óra sem.
    const orak = (this.napiOrarend || []).filter((o: any) => o && !(o.helyettesites && o.tanar == this.uuid)
      && Number(o.elmaradt) !== 1);
    return { konyvelt: orak.filter((o: any) => this.oraZold(o)).length, osszes: orak.length };
  }

  /*  NKP-EREDMÉNYEK BEILLESZTÉSE az óra értékelés-ablakából is – ugyanaz a komponens, mint
   *  az Értékelések menüben. Az ablak nem ment: a kiválasztott értékeket a névsor mezőibe
   *  írja, és a megszokott Mentés rögzít (minden ellenőrzéssel). */
  async nkpBeillesztes() {
    const nevsor = (this.kivalasztottOra?.osztaly_nevsor || [])
      .map((t: any) => ({ oktazon: String(t.oktazon), nev: t.nev || `${t.viselt_vez || ''} ${t.viselt_ker || ''}`.trim(), email: t.email || null }));
    const m = await this.modalCtrl.create({
      component: NkpBeillesztesComponent,
      componentProps: { nevsor, mod: this.kivalasztottOra?.osztalyozasimod === '1' ? '1' : '2', modZarolt: false },
      cssClass: 'nkp-modal',
    });
    await m.present();
    const { data, role } = await m.onWillDismiss();
    if (role !== 'ok' || !data?.ertekek) return;
    if (data.mod) this.kivalasztottOra.osztalyozasimod = data.mod;
    let db = 0;
    for (const t of (this.kivalasztottOra?.osztaly_nevsor || [])) {
      const e = data.ertekek[String(t.oktazon)];
      if (e === undefined) continue;
      t.osztalyzat = e;
      db += 1;
    }
    this.datas.sendToast(`${db} tanulónál kitöltve. Ellenőrizd a névsort, add meg a típust és a témát, majd Mentés.`, 'success');
    this.ref.detectChanges();
  }

  /** A naplóban zöld (lekönyvelt) órák: csak a SAJÁT téma számít, a javaslat nem. */
  oraZold(ora: any): boolean {
    return !!(ora?.konyvelte && (this.normalizaltTema(ora?.rogzitett_tema) || ora?.temaModositott));
  }

  private isOraLekonyvelt(ora: any): boolean {
    if (typeof ora?.eredetilegLekonyvelt === 'boolean') {
      return ora.eredetilegLekonyvelt;
    }
    return !!(ora?.konyvelte && String(ora?.tema || '').trim());
  }

  private ensureTomb(ora: any, mezonev: string) {
    if (!Array.isArray(ora?.[mezonev])) ora[mezonev] = [];
  }

  /*  AZ AZONOSÍTÓ ALAKJA NEM DÖNTHET A PIROS SÁVRÓL.
   *
   *  A névsor az `oktazon`-t SZÁMKÉNT hozza (tanulo.oktazon BIGINT), a jelölés-listák
   *  viszont vegyesen állnak: a napló számot ír, a „Hiányzók átvétele” és a mulasztás-
   *  kezelő SZÖVEGET („727…”). A sablon típusra érzékenyen keres (`indexOf`), ezért a
   *  szövegként álló hiányzó nem lett piros, a Jelenlét gomb tiltva maradt, vagyis
   *  visszavonni sem lehetett. A kolléga újra „Hiányzik”-ot nyomott, és a tanuló
   *  MÁSODSZOR is bekerült, most számként – élesben: ["72728126598", …, "72822470041",
   *  72822470041] (2026-09-15, 3. óra). A kettőzött sort a mulasztás-összesítők
   *  kétszer számolták.
   *
   *  Ezért betöltéskor (és átvételkor) minden elemet a NÉVSOR saját alakjára igazítunk,
   *  a kettőzést pedig kiszűrjük – a következő mentés már tisztán írja vissza. Akit a
   *  névsor nem ismer (pl. időközben kilépett), annak az eleme változatlanul marad:
   *  adatot nem dobunk el. */
  private static readonly JELOLES_LISTAK = ['hianyzo', 'hazihiany', 'felszhiany', 'felmentes', 'dicseret', 'jelenvolt'];

  private nevsorAlakja(ora: any): Map<string, any> {
    const nevsor: any[] = Array.isArray(ora?.osztaly_nevsor) ? ora.osztaly_nevsor : [];
    return new Map(nevsor
      .filter((n: any) => n && n.oktazon !== null && n.oktazon !== undefined)
      .map((n: any) => [String(n.oktazon).trim(), n.oktazon]));
  }

  private jelolesekIgazitasa(ora: any) {
    const alak = this.nevsorAlakja(ora);
    for (const mezo of NyilvantartoComponent.JELOLES_LISTAK) {
      if (!Array.isArray(ora?.[mezo])) continue;
      const lattuk = new Set<string>();
      const ki: any[] = [];
      for (const elem of ora[mezo]) {
        const nyers = elem !== null && typeof elem === 'object' ? elem.oktazon : elem;
        const kulcs = String(nyers ?? '').trim();
        if (!kulcs || lattuk.has(kulcs)) continue;
        lattuk.add(kulcs);
        ki.push(alak.has(kulcs) ? alak.get(kulcs) : elem);
      }
      ora[mezo] = ki;
    }
  }

  /*  A JELÖLÉS CSAK EZT AZ ÓRÁT ÉRINTI.
   *
   *  Korábban a hiányzó bejelölése magától átterjedt a kolléga aznapi többi órájára.
   *  Ez csendben írt olyan órákba, amiket a kolléga meg sem nyitott – és csak a SAJÁT
   *  óráit nézte, tehát a más tanár által beírt hiányzóról nem tudott. A nap többi
   *  órájából mostantól a „Hiányzók átvétele" gomb hoz át, kérésre és láthatóan. */
  jelolHianyzo(ora: any, tanulo: any) {
    this.ensureTomb(ora, 'hianyzo');
    if (ora.hianyzo.indexOf(tanulo.oktazon) === -1) {
      ora.hianyzo.push(tanulo.oktazon);
    }
  }

  jelolJelenlet(ora: any, tanulo: any) {
    this.ensureTomb(ora, 'hianyzo');
    const idx = ora.hianyzo.indexOf(tanulo.oktazon);
    if (idx !== -1) {
      ora.hianyzo.splice(idx, 1);
    }
  }

  /*  HIÁNYZÓK ÁTVÉTELE A NAP TÖBBI ÓRÁJÁBÓL.
   *
   *  A hasznos eset az, hogy a gyereket REGGEL jelölte be valaki – jellemzően MÁS
   *  tanár –, és a délutáni órán ne kelljen újra végigmenni a névsoron. A napi órarend
   *  a saját órákra szűr, ezért ezt a kérdést a szerver válaszolja meg: a nap összes
   *  óráját nézi, tanártól függetlenül.
   *
   *  Nem ír azonnal: előbb megmutatja, kit hol jelöltek be – a beírás a kolléga döntése.
   *  Aki már hiányzik ezen az órán, azzal nincs dolgunk. */
  atvetelFut: any = {};

  async hianyzokAtvetele(ora: any) {
    const nevsor: any[] = ora?.osztaly_nevsor || [];
    if (!nevsor.length) return;
    const datum = moment(this.currentday?.dayDate).format('YYYY-MM-DD');
    if (!datum || datum === 'Invalid date') return;

    this.atvetelFut[ora.id] = true;
    try {
      const valasz: any = await firstValueFrom(this.http.post(
        '/api/orarend/nap-hianyzoi/' + this.sajatIntezmeny.intezmenyId,
        { datum, ora_id: ora.id, oktazonok: nevsor.map((n) => n.oktazon) }));

      this.ensureTomb(ora, 'hianyzo');
      this.jelolesekIgazitasa(ora);
      const mar = new Set((ora.hianyzo || []).map((x: any) => String(x)));
      const nevrol = new Map(nevsor.map((n: any) => [String(n.oktazon), n.nev]));
      //  A kiszolgáló az azonosítót SZÖVEGKÉNT adja vissza; a listába a névsor saját
      //  alakja kerül, különben a sablon nem ismerné fel (nem lenne piros sáv, és a
      //  Jelenlét gombbal sem lehetne visszavonni).
      const alak = this.nevsorAlakja(ora);

      const ujak = (valasz?.tanulok || []).filter((t: any) => !mar.has(String(t.oktazon)));
      if (!ujak.length) {
        this.datas.sendToast('A nap többi óráján nincs olyan beírt hiányzó, aki itt még ne szerepelne.', 'success');
        return;
      }

      const sorok = ujak.map((t: any) => {
        const honnan = (t.honnan || [])
          .map((h: any) => `${h.ora ? h.ora + '. óra' : ''}${h.tantargy ? ' ' + h.tantargy : ''}`
            + `${h.tanar ? ' (' + h.tanar + ')' : ''}`)
          .filter(Boolean).join(', ');
        return `• ${nevrol.get(String(t.oktazon)) || t.oktazon}${honnan ? ' — ' + honnan : ''}`;
      });

      if (!confirm(`${ujak.length} tanuló hiányzik a nap más óráján:\n\n${sorok.join('\n')}\n\n`
        + 'Beírjuk őket erre az órára is?')) return;

      for (const t of ujak) {
        const kulcs = String(t.oktazon).trim();
        const oktazon = alak.has(kulcs) ? alak.get(kulcs) : t.oktazon;
        if (!ora.hianyzo.some((x: any) => String(x) === kulcs)) ora.hianyzo.push(oktazon);
      }
      this.datas.sendToast(`${ujak.length} hiányzó átvéve. A mentéssel rögzül.`, 'success');
    } catch (e: any) {
      this.datas.sendToast(e?.error?.error || 'Az átvétel nem futott le.', 'error');
    } finally {
      this.atvetelFut[ora.id] = false;
    }
  }

  // --- Opcionális részvétel (nem tanórai célú csoport): üres alap, "Jelen volt" / "Nem volt" jelölés ---
  // Állapotok: nincs egyik tömbben sem = üres; jelenvolt = jelen volt; hianyzo = nem volt (NEM hiányzás,
  // mert ezek a csoportok hianyzas_szamit=0 alatt nem számítanak hiányzásba).
  jelolJelenvolt(ora: any, tanulo: any) {
    this.ensureTomb(ora, 'jelenvolt');
    this.ensureTomb(ora, 'hianyzo');
    const oktazon = tanulo.oktazon;
    const h = ora.hianyzo.indexOf(oktazon);
    if (h !== -1) ora.hianyzo.splice(h, 1);
    const j = ora.jelenvolt.indexOf(oktazon);
    if (j === -1) ora.jelenvolt.push(oktazon); else ora.jelenvolt.splice(j, 1); // újrakattintás → üres
  }
  jelolNemvolt(ora: any, tanulo: any) {
    this.ensureTomb(ora, 'jelenvolt');
    this.ensureTomb(ora, 'hianyzo');
    const oktazon = tanulo.oktazon;
    const j = ora.jelenvolt.indexOf(oktazon);
    if (j !== -1) ora.jelenvolt.splice(j, 1);
    const h = ora.hianyzo.indexOf(oktazon);
    if (h === -1) ora.hianyzo.push(oktazon); else ora.hianyzo.splice(h, 1); // újrakattintás → üres
  }
  /** „7.a: 5, 7.b: 7 – összesen 12” – csak csoportos órán (ott jön `osztaly_megoszlas`). */
  megoszlasSzoveg(megoszlas: any): string {
    if (!Array.isArray(megoszlas) || !megoszlas.length) return '';
    const ossz = megoszlas.reduce((s: number, x: any) => s + Number(x?.db || 0), 0);
    return `${megoszlas.map((x: any) => `${x.osztaly}: ${x.db}`).join(', ')} – összesen ${ossz}`;
  }

  jelenvoltAllapot(ora: any, tanulo: any): 'jelen' | 'nem' | '' {
    if ((ora?.jelenvolt || []).indexOf(tanulo.oktazon) !== -1) return 'jelen';
    if ((ora?.hianyzo || []).indexOf(tanulo.oktazon) !== -1) return 'nem';
    return '';
  }

  temaValtozott(ora: any, ujTema: any) {
    ora.tema = ujTema;
    ora.temaModositott = this.normalizaltTema(ujTema) !== this.normalizaltTema(ora.temaEredeti);
  }

  oraPerkChanger(o, n, mit) {
    if (o[mit].indexOf(n.oktazon) == -1)
      o[mit].push(n.oktazon)
    else
      o[mit].splice(o[mit].indexOf(n.oktazon), 1)
  }


  getWeekSum(idx) {
    try {
      let d = 0.0;
      if (idx < 7) {
        for (let index = 0; index < idx; index++) {
          d += parseFloat(
            this.diffDateHours(
              this.daysInMonth[index].nyilvantartas.start,
              this.daysInMonth[index].nyilvantartas.end
            )
          );
        }
      } else {
        for (let index = idx - 6; index < idx; index++) {
          if (this.daysInMonth[index].nyilvantartas)
            d += parseFloat(
              this.diffDateHours(
                this.daysInMonth[index].nyilvantartas.start,
                this.daysInMonth[index].nyilvantartas.end
              )
            );
        }
      }
      this.weeksumi++;
      return d.toFixed(2);
    } catch (error) {
      return '-';
    }
  }

  getWeekSumByWeek(week: number) {
    try {
      let d = 0.0;
      for (const day of this.daysInMonth) {
        if (!day || day.week !== week) continue;
        if (!day.nyilvantartas?.start || !day.nyilvantartas?.end) continue;
        d += parseFloat(this.diffDateHours(day.nyilvantartas.start, day.nyilvantartas.end));
      }
      return d.toFixed(2);
    } catch (error) {
      return '0.00';
    }
  }

  isWeekBoundary(idx: number) {
    const currentDay = this.daysInMonth[idx];
    const nextDay = this.daysInMonth[idx + 1];
    if (!currentDay) return false;
    return !nextDay || currentDay.week !== nextDay.week;
  }

  isPartialWeek(week: number) {
    return this.daysInMonth.filter(day => day?.week === week).length < 7;
  }

  getMonthData() {
    //console.log(this.today.getDate());
    let days = 0;
    let bd = 0;
    let ok = 0;
    for (let index = 0; index < this.daysInMonth.length; index++) {
      const nap = this.daysInMonth[index];
      const ny = nap.nyilvantartas;
      const munkanap = !nap.isWeekend && !nap?.isHoliday;

      if (ny?.start && ny?.end) {
        days += parseFloat(
          this.diffDateHours(
            ny.start,
            ny.end
          )
        );
      }

      if (!munkanap) continue;

      if (this.isKitoltetlenJelenlet(ny)) {
        bd++;
        continue;
      }

      if (Number(ny.status) === 1) {
        if (this.isNapTeljes(ny, nap.dayDate)) ok++;
        else bd++;
      } else {
        ok++;
      }
    }
    return { days: days, bd: bd, ok: ok };
  }

  private normalizeStatKey(value: any): string {
    return String(value ?? '').trim().toLowerCase();
  }

  private getPossibleStatKeys(): string[] {
    const keys = [
      this.uuid,
      this.user$?.username,
      this.userMetadata?.adid,
      this.userMetadata?.username,
      this.userMetadata?.auth0id,
    ]
      .map((item) => this.normalizeStatKey(item))
      .filter((item) => !!item);

    return [...new Set(keys)];
  }

  private getStatRow(source: any): any {
    if (!source || typeof source !== 'object') return {};

    const possibleKeys = this.getPossibleStatKeys();

    for (const key of possibleKeys) {
      if (source[key]) return source[key];
    }

    const matchingEntry = Object.entries(source).find(([key]) =>
      possibleKeys.includes(this.normalizeStatKey(key))
    );

    return matchingEntry?.[1] ?? {};
  }

  getUtazasKm() {
    const row = this.getStatRow(this.utazas);
    return Number(row?.km ?? 0);
  }

  getRemainingVacation() {
    const row = this.getStatRow(this.szabadsag);
    const total = Number(row.szabadsag ?? 0);
    const used = Number(row.felhasznalt_szabadsag ?? 0);
    const usedInMonth = Number(row.honapban_felhasznalt_szabadsag ?? 0);
    return {
      remaining: total - used,
      usedInMonth,
    };
  }

  getRemainingSickLeave() {
    const row = this.getStatRow(this.szabadsag);
    const total = Number(row.tappenz ?? 0);
    const used = Number(row.felhasznalt_tappenz ?? 0);
    const usedInMonth = Number(row.honapban_felhasznalt_tappenz ?? 0);
    return {
      remaining: total - used,
      usedInMonth,
    };
  }

  recomputeStatistics() {
    const monthData = this.getMonthData();
    const vacation = this.getRemainingVacation();
    const sickLeave = this.getRemainingSickLeave();

    this.statsDisplay = {
      bookedDays: Number(monthData?.ok ?? 0),
      incompleteDays: Number(monthData?.bd ?? 0),
      hours: Number(monthData?.days ?? 0).toFixed(2),
      travelKm: Number(this.getUtazasKm() ?? 0),
      remainingVacation: Number(vacation?.remaining ?? 0),
      usedVacationInMonth: Number(vacation?.usedInMonth ?? 0),
      remainingSickLeave: Number(sickLeave?.remaining ?? 0),
      usedSickLeaveInMonth: Number(sickLeave?.usedInMonth ?? 0),
    };
  }

  getData(y, m) {
    const sorszam = ++this.adatKeresSorszam;
    this.getHolidays(true).pipe(
      switchMap((response1: any[]) => {
        const holidays = Array.isArray(response1) ? response1 : [];
        this.holidays = holidays;

        return forkJoin({
          nyilvantartas: this.http.get('/api/nyilvantartas/riportuser/' + this.uuid + '/' + (this.userMetadata.auth0id || 'NA') + '/' + y + '/' + m + '/' + this.sajatIntezmeny.intezmenyId),
          orak: this.http.get('/api/orarend/count-nap/' + y + '/' + m + '/' + this.uuid + '/' + this.sajatIntezmeny.intezmenyId),
          helyettesitesek: this.http.get('/api/orarend/helyettesites/napok/' + y + '/' + m + '/' + this.uuid + '/' + this.sajatIntezmeny.intezmenyId)
        }).pipe(
          switchMap(async (response: any) => {
            // Közben újabb lekérés indult (más hónap/munkatárs) – ezt a választ eldobjuk.
            if (sorszam !== this.adatKeresSorszam) return {};
            this.daysInMonth = [];
            this.napiOraszamMap = response?.orak || {};
            this.napiHelyettesitesMap = response?.helyettesitesek || {};
            this.munkaidoEllenoriz();
            try {
              this.loading.dismiss();
            } catch (e) {
              console.error(e)
            }
            await this.populateDaysInMonth(response?.nyilvantartas || [], holidays);
            this.recomputeStatistics();
            try {
              this.loading.dismiss();
            } catch (error) { }
            return {}; // Complete the observable chain
          })
        )
      }),
      catchError(error => {
        console.error('Error fetching data:', error);
        // A kilépés előtt is zárjuk a spinnert, nehogy fent ragadjon.
        try { this.loading.dismiss(); } catch (e) { }
        alert('Nem sikerült betölteni az adatokat! Kérjük próbálja újra.');
        this.logout()
        return of({}); // Handle errors appropriately
      })
    ).subscribe();

  }
  logout() {
    this.auth.logout()
  }
  validateForm() {

    //  Időt a dolgozik (1), a kiküldetés (4) és a digitális távoktatás (7) kér. A 4-es és 7-es
    //  idő nélkül is menthető (eddig is az volt), de ha beírják, ugyanúgy ellenőrizzük.
    const j = Number(this.jelenlet);
    if (this.jelenlet && ![1, 4, 7].includes(j)) return false;
    if ((j === 4 || j === 7) && !`${this.erko ?? ''}${this.erkp ?? ''}${this.tavo ?? ''}${this.tavp ?? ''}`.trim()) return false;
    else if (
      this.erko.length != 0 &&
      this.erkp.length != 0 &&
      this.tavo.length != 0 &&
      this.tavp.length != 0
    ) {
      if (this.erko > this.tavo || parseInt(this.erko) < 6 || parseInt(this.erko) > 21 || parseInt(this.tavo) < 6 || parseInt(this.tavo) > 21 || (this.erko == this.tavo && this.erkp >= this.tavp))
        return true
      else
        return false
    } else if (
      this.erko.length != 0 &&
      this.erkp.length != 0 &&
      this.tavo.length == 0 &&
      this.tavp.length == 0
    ) {
      if (parseInt(this.erko) < 6 || parseInt(this.erko) > 21)
        return true
      else
        return false
    }
    else if (
      this.erko.length == 0 &&
      this.erkp.length == 0 &&
      this.tavo.length == 0 &&
      this.tavp.length == 0
    ) return true
    else return true;
  }

  private buildOrarendMentendoSor(h: any, jelolKonyveltnek: boolean = false) {
    /*  Az érintetlen óra témája NEM mentődik: a tanmenet javaslata maradjon javaslat.
     *  Ha beírnánk, a következő betöltéskor már rögzített témaként jönne vissza, és
     *  onnantól semmi nem különböztetné meg a kolléga saját beírásától. A hiányzás, a
     *  jelenlét és a többi mező viszont ilyenkor is mentődik – azt a napló más
     *  pontjairól (pl. a hiányzás átvezetéséből) is kaphatta. */
    const erintve = this.oraErintve(h);
    const mentendoTema = erintve ? this.getMentendoTema(h) : null;
    const legyenKonyvelt = jelolKonyveltnek && erintve && !!mentendoTema;

    return {
      id: h.id,
      hianyzo: h.hianyzo || [],
      hazihiany: h.hazihiany || [],
      felszhiany: h.felszhiany || [],
      felmentes: h.felmentes || [],
      dicseret: h.dicseret || [],
      jelenvolt: h.jelenvolt || [],
      konyvelte: legyenKonyvelt ? this.uuid : (h.konyvelte ?? null),
      konyvelve: legyenKonyvelt ? moment() : (h.konyvelve ?? null),
      tema: mentendoTema,
      hazifeladat: h.hazifeladat ?? null,
    };
  }

  private buildOrarendMentendoTomb(orak: any[], jelolKonyveltnek: boolean = false): any[] {
    return (orak || []).map(h => this.buildOrarendMentendoSor(h, jelolKonyveltnek));
  }

  private normalizaltTema(tema: any): string {
    return String(tema ?? '').trim();
  }

  private hasFelhasznaloAltalKonyvelhetoTema(ora: any): boolean {
    const tema = this.normalizaltTema(ora?.tema);
    return !!tema;
  }

  private getMentendoTema(ora: any): string | null {
    return this.normalizaltTema(ora?.tema) || null;
  }

  private hasMunkaido(nyilvantartas: any): boolean {
    if (!nyilvantartas?.start || !nyilvantartas?.end) return false;

    const start = new Date(nyilvantartas.start);
    const end = new Date(nyilvantartas.end);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;

    return start.getTime() !== end.getTime();
  }

  isKitoltetlenJelenlet(nyilvantartas: any): boolean {
    if (!nyilvantartas) return true;
    if (Number(nyilvantartas.status) === 0) return true;
    return Number(nyilvantartas.status) === 1 && !this.hasMunkaido(nyilvantartas);
  }

  private getNapiOraOsszesites(dayDate?: Date) {
    if (!dayDate) return { relevans: 0, naplozott: 0, ora: 0 };
    const nap = String(new Date(dayDate).getDate());
    return this.napiOraszamMap?.[nap] || { relevans: 0, naplozott: 0, ora: 0 };
  }

  /** A jelenléti táblázat „Óraszám” / „Könyvelt órák” oszlopa: az aznapi órák és ebből a könyveltek. */
  napiOra(day: any) {
    return this.getNapiOraOsszesites(day?.dayDate);
  }

  getNapiHelyettesitesOsszesites(day: any) {
    const nap = day?.dayDate ? String(new Date(day.dayDate).getDate()) : String(day?.dayNumber ?? '');
    const aktualis = this.napiHelyettesitesMap?.[nap];
    if (aktualis) {
      return {
        eseti: Number(aktualis.eseti || 0),
        tartos: Number(aktualis.tartos || 0),
        kotottTulora: Number(aktualis.kotottTulora || 0),
      };
    }

    const ny = day?.nyilvantartas || {};
    return {
      eseti: Number(ny.helyettesites || 0),
      tartos: Number(ny.tartos || 0),
      kotottTulora: Number(ny.kotottTulora || ny.tulora || 0),
    };
  }

  // Fast checker for month table: uses local nyilvantartas fields only, no extra API calls.
  isNapTeljes(nyilvantartas: any, dayDate?: Date): boolean {
    if (!nyilvantartas || Number(nyilvantartas.status) !== 1) return false;

    const osszesites = this.getNapiOraOsszesites(dayDate);
    const orakRendben = osszesites.relevans === 0 || osszesites.naplozott >= osszesites.relevans;

    return this.hasMunkaido(nyilvantartas) && orakRendben;
  }

  isNapReszleges(nyilvantartas: any, dayDate?: Date): boolean {
    if (!nyilvantartas || Number(nyilvantartas.status) !== 1) return false;
    if (this.isNapTeljes(nyilvantartas, dayDate)) return false;
    return true;
  }

  napGyorsEllenorzesUzenet(nyilvantartas: any, dayDate?: Date): string {
    if (!nyilvantartas || Number(nyilvantartas.status) !== 1) return '';

    const osszesites = this.getNapiOraOsszesites(dayDate);
    if (osszesites.relevans === 0) {
      return this.hasMunkaido(nyilvantartas)
        ? 'Teljes kitoltes (0 naplozando tanora)'
        : 'Hianyos: erkezes/tavozas';
    }

    if (this.isNapTeljes(nyilvantartas, dayDate)) return 'Teljes kitoltes';

    const hiany: string[] = [];
    if (!this.hasMunkaido(nyilvantartas)) hiany.push('erkezes/tavozas');
    if (osszesites.naplozott < osszesites.relevans) hiany.push(`naplozott orak ${osszesites.naplozott}/${osszesites.relevans}`);
    return 'Hianyos: ' + hiany.join(', ');
  }

  async populateDaysInMonth(response, holidays = this.holidays) {
    this.munkanapok = 0
    const holidayList = Array.isArray(holidays) ? holidays : [];
    const nyilvantartasRows = Array.isArray(response) ? response : [];
    const days = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    for (let i = 0; i < days; i++) {
      const date = new Date(this.selectedYear, this.selectedMonth - 1, i + 1); // Remember, months are 0-indexed
      const dateTime = new Date(date).setHours(0, 0, 0, 0);
      const dayNumber = date.getDay();
      const dayName = date.toLocaleString('default', { weekday: 'long' });
      let isWeekend = dayNumber === 0 || dayNumber === 6;
      try {
        for (let it of holidayList) {
          if (it.type == -2 && new Date(it.date).setHours(0, 0, 0, 0) == dateTime) {
            isWeekend = false
            break;
          }
        }
      } catch (e) {
      }
      /*this.daysInMonth.push({
        dayNumber: i,
        dayName: dayName,
        isWeekend: isWeekend,
        nyilvantartas: null,
      });*/
      let isHoliday = false;
      try {
        for (let it of holidayList) {
          if (it.type != -2 && new Date(it.date).setHours(0, 0, 0, 0) == dateTime) {
            isHoliday = true
            break;
          }
        }
      } catch (e) {
      }

      for (let element of nyilvantartasRows) {
        if (new Date(element.start).getDate() == i + 1) {
          if (!isHoliday && !isWeekend && (element.nyilvantartas?.status == 1 || element.nyilvantartas?.status == 4)) this.munkanapok++
          this.daysInMonth[i] = {
            dayNumber: i + 1,
            dayDate: date,
            dayName: dayName,
            isWeekend: isWeekend,
            nyilvantartas: element,
            isHoliday: isHoliday,
            week: this.getWeekOfMonth(date)
          };
          break;
        }
      }
      if (!this.daysInMonth[i]) {
        if (!isHoliday && !isWeekend) this.munkanapok++
        this.daysInMonth[i] = {
          dayNumber: i + 1,
          dayName: dayName,
          dayDate: date,
          isWeekend: isWeekend,
          nyilvantartas: null,
          isHoliday: isHoliday,
          week: this.getWeekOfMonth(date)
        };
      }
    }
    try {
      this.loading.dismiss();
    } catch (e) {
      console.error(e)
    }
  }


  /*  #1068 – KÖNYVELETLEN ÓRÁK: a saját elszámolás csak akkor nyomtatható, ha a hónap eddig
   *  eltelt részében minden óra naplózva van. A kiszolgáló dönt (munkaido-elszamolas.js ›
   *  /ellenorzes): a `tilt` a nem jogosult kolléga saját kérésére igaz, a vezetésnek csak
   *  figyelmeztetés. A gomb a választ követi; a PDF-kérést a kiszolgáló is elutasítja (409). */
  munkaidoEll: { konyveletlen: number; uzenet: string; tilt: boolean } | null = null;
  private munkaidoEllKulcs = '';

  async munkaidoEllenoriz() {
    const intezmeny = this.sajatIntezmeny?.intezmenyId;
    if (!intezmeny || !this.selectedYear || !this.selectedMonth) return;
    const kulcs = `${this.selectedYear}-${this.selectedMonth}-${this.uuid || ''}`;
    this.munkaidoEllKulcs = kulcs;
    try {
      const q = `ev=${this.selectedYear}&ho=${this.selectedMonth}&allomany=${encodeURIComponent(this.uuid || '')}`;
      const r: any = await firstValueFrom(this.http.get(`/api/munkaido-elszamolas/ellenorzes/${intezmeny}?${q}`));
      if (this.munkaidoEllKulcs === kulcs) this.munkaidoEll = r;   // közben hónapot váltott → eldobjuk
    } catch {
      if (this.munkaidoEllKulcs === kulcs) this.munkaidoEll = null; // nem sikerült: a kiszolgáló kapuja úgyis őriz
    }
  }

  /** A havi munkaidő-elszámolás (KRÉTA-minta) PDF-je – a kiválasztott hónapra és kollégára. */
  munkaidoElszamolas() {
    if (this.munkaidoEll?.tilt) { alert(this.munkaidoEll.uzenet); return; }
    const q = `ev=${this.selectedYear}&ho=${this.selectedMonth}&allomany=${encodeURIComponent(this.uuid || '')}`;
    this.datas.megnyitFajl(`/api/munkaido-elszamolas/${this.sajatIntezmeny.intezmenyId}?${q}`, 'Munkaidő-elszámolás');
  }

  /*  AZ ÖSSZESÍTŐ NYOMTATÁSA a kiszolgáló riport-motorjával (backend/pdf-riport.js) – a
   *  munkaidő-elszámolás arculatával. A képernyő táblázatát visszük át (riport-pdf.ts ›
   *  domTablaKinyer): a „Műveletek” oszlop (gombok) kimarad, az ikonok rövid jelek lesznek, a
   *  heti összesítő sor elválasztó sáv. Hiba esetén a régi, böngészős PDF készül. */
  async printData() {
    const tabla = document.getElementById('printable') as HTMLTableElement;
    const { oszlopok, sorok } = domTablaKinyer(tabla, { kihagy: (nev) => /^műveletek$/i.test(nev) });
    const fajlnev = `${this.selectedYear}-${this.selectedMonth}_${this.sajatIntezmeny?.intezmenyName ?? ''}.pdf`;
    if (!oszlopok.length) { this.printDataRegi(); return; }
    //  Két „Óraszám” oszlop áll a képernyőn: az első a megtartott órák, az utolsó a jelenlét
    //  szerinti munkaidő („8.00 óra”) – a papíron legyen egyértelmű.
    const oraszam = oszlopok.map((o, i) => (o.nev === 'Óraszám' ? i : -1)).filter((i) => i >= 0);
    if (oraszam.length > 1) oszlopok[oraszam[oraszam.length - 1]].nev = 'Munkaidő';
    oszlopok.forEach((o, i) => { o.igazitas = i === 0 ? 'bal' : 'kozep'; });
    const honap = honapCimke(this.selectedYear, this.selectedMonth);
    const keszito = [this.userMetadata?.viselt_vez, this.userMetadata?.viselt_ker].filter(Boolean).join(' ');
    try {
      await this.datas.riportPdf({
        intezmeny: this.sajatIntezmeny?.intezmenyId,
        cim: 'Munkaidő-nyilvántartás',
        cimKieg: 'havi összesítő',
        alcim: `${this.sajatnev || ''} · ${honap}`,
        adatsav: [['Munkatárs', this.sajatnev || ''], ['Időszak', honap]],
        lapmeret: 'A4', tajolas: 'allo', betumeret: 8.5,
        tablak: [{ cim: 'Napi jelenlét és óraszám', oszlopok, sorok }],
        lablec: {
          kelt: true, alairok: [this.sajatnev || 'Munkavállaló', 'Ellenőrizte / vezető'],
          keszitette: keszito, megjegyzes: `${IKON_JELMAGYARAZAT} ✓ = a nap teljes, – = tanítás nélküli nap.`,
        },
        fajlnev,
      }, fajlnev, 'letolt');
    } catch (e: any) {
      console.warn('Összesítő-PDF (kiszolgáló) hiba, böngészős tartalék:', e);
      this.datas.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      this.printDataRegi();
    }
  }

  printDataRegi() {
    const table = document.getElementById('printable');

    let pdf = new jsPDF('p', 'mm', 'a4');


    //pdf.setFont('Bitter-Regular', 'normal')
    pdf.addFileToVFS("Bitter-Regular-normal.ttf", font);
    pdf.addFont("Bitter-Regular-normal.ttf", "Bitter-Regular", "normal");
    pdf.addFileToVFS("Bitter-Bold-normal.ttf", fontB);
    pdf.addFont("Bitter-Bold-normal.ttf", "Bitter-Bold", "bold");
    pdf.setFont("Bitter-Regular");

    pdf.text("Munkaidő-nyilvántartás " + this.selectedYear + "-" + this.selectedMonth, 60, 10);


    function getBackgroundColor(cell) {
      return window.getComputedStyle(cell, null).getPropertyValue('background-color');
    }

    let bed = "data:image/png;base64,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"
    let alert = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAACSVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD////V856KAAAAwXRSTlMAAQIDBAYHCAkKCwwNDg8QERITFBUWGBobHB0eHyEjJCUpKy0uLzAxMjM0NTY3OTs9Pj9AQ0RJSkxNUFFSU1RVV1pcXV5fYWJkZWZrbW5vcHFzdHd4eXp7fH1+f4CBgoeIiYqLjI2Oj5CUlZmdnp+hoqOkpaanqKqrrK2wsbK2t7i6u7y9vr/AwcLDxMXGyMnKy8zNzs/Q0dLT1NXW19jZ3d7f4OHi4+Tl5+jp6uvs7e7v8PHy8/T19vf4+fr7/P3+V8azwgAAAAFiS0dEwv1vvtQAAAluSURBVBgZ7cHtfx5kfcbhsy0kPC7B4VImNmoijtmoeG+pD4lsCaKJmgqkgznSFRM2W9dKgcSndK6BIZroqAnjMbWSOAbmpowtWWnK7pz/2d7KZ9Dmuq7PXly/fI9DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuT7whfsfPXPuzc3N8+eeOflXX7hJ2EFue2ip5XdpLR7pFXaE677+nN/Ts1+7Woiu44Gm39crQ7uFyHbd9bov66U7hbg+PO8r+udbhaDu+J234Y0/E0IaveRteec+IZ62f/C2nbxGCOa6nzvBz64TQrn6J07yRJsQyK4fONHMLiGOcSe7Rwjjs+842TufEYK4/rfO8Mq1QgxTznJECKH3HWe59DEhgh870/eFAD7acqbWx4T6nXS27wnVu/GCs719o1C7u11gWKjdnAv8k1C5azZd4GKbULfPuMinhLqNu8i9Qt0ec5FHhLr93EV+KtRtxUXOCXXbdJELQt3+x0UuCXW75CIXhbptushFoW4bLrIh1K3pImtC3VZdZEWo21kXWRbqtuQii0LdFlxkXqjbnIucFup2ykVmhbrNuMi0ULcTLnJcqNsxFzkq1G3KRSaFuh12kQmhbodcZFyo20EXGRPqNuoiI0Ldhl1kSKjboIsMCHU74CL9Qt0aLtIQ6tbnIvuFuvW6SI9Qt24X2SfUba+LdAl163SRDqFu7S7SJlSu5QItoXYbLrAu1K7pAmtC7VZdYEWo3VkXWBZqt+QCi0LtFlxgXqjdnAucFmp3ygVmhdrNuMC0ULsTLnBcqN0xFzgq1G7KBSaF2h12gQmhdodcYFyo3UEXGBNqN+oCI0Lthl1gSKjdoAsMCLU74AL9Qu0aLtAQatfnAvuF2vW6QI9Qu24X2CfUbq8LdAm163SBDqF27S7QJlSv5WwtoX4bzrYu1K/pbGtC/VadbUWo31lnWxbqt+Rsi0L9FpxtXqjfnLOdFup3ytlmhfrNONu0UL8TznZcqN8xZzsq1G/K2SaF+h12tgmhfoecbVyo30FnGxPqN+psI0L9hp1tSKjfoLMNCPU74Gz9Qv0aztYQ6tfnbPuF+vU6W49Qv25n2yfUb6+zdQn163S2DqF+7c7WJgTQcqaWEMGGM60LETSdaU2IYNWZVoQIzjrTshDBkjMtChEsONO8EMGcM50WIjjlTLNCBDPONC1EcMKZjgsRHHOmo0IEU840KURw2JkmhAgOOdO4EMFBZxoTIhh1phEhgmFnGhIiGHSmASGCA87UL0TQcKaGEEGfM+0XIuh1ph4hgm5n2idEsNeZuoQIOp2pQ4ig3ZnahBBaztISYthwlnUhhqazrAkxrDrLihDDWWdZFmJYcpZFIYYFZ5kXYphzltNCDKecZVaIYcZZpoUYTjjLcSGGY85yVIhhylkmhRgOO8uEEMMhZxkXYjjoLGNCDKPOMiLEMOwsQ0IMg84yIMRwwFn6hRgaztIQYuhzlv1CDL3O0iPE0O0s+4QY9jpLlxBDp7N0CDG0O0ubEETLGVpCFBvOsC5E0XSGNSGKVWdYEaI46wzLQhRLzrAoRLHgDPNCFHPOcFqI4pQzzApRzDjDtBDFCWc4LkRxzBmOClFMOcOkEMVhZ5gQojjkDONCFAedYUyIYtQZRoQohp1hSIhi0BkGhCgOOEO/EEXDGRpCFH3OsF+IotcZeoQoup1hnxDFXmfoEqLodIYOIYp2Z2gTwmg5WUuIY8PJ1oU4mk62JsSx6mQrQhxnnWxZiGPJyRaFOBacbF6IY87JTgtxnHKyWSGOGSebFuI44WTHhTiOOdlRIY4pJ5sU4jjsZBNCHIecbFyI46CTjQlxjDrZiBDHsJMNCXEMOtmAEMcBJ+sX4mg4WUOIo8/J9gtx9DpZjxBHt5PtE+LY62RdQhydTtYhxNHuZG1CIC0nagmRbDjRuhBJ04nWhEhWnWhFiOSsEy0LkSw50aIQyYITzQuRzDnRaSGSU040K0Qy40TTQiQnnOi4EMkxJzoqRDLlRJNCJIedaEKI5JATjQuRHHSiMSGSUScaESIZdqIhIZJBJxoQIul3on4hkoYTNYRI+pyoT4ikx4l6hEi6nahbiGSvE3UJkXQ6UacQSZsTtQmhXHCSC0Isv3aSl4VYnnKSJ4RYHnOS7wmxTDrJ3wqxfM5JPifE0vZfTrDRLgTzIyf4oRDNXU4wLETT+Z/etrc6hHAe8LaNC/Fc82/eplevFQIa8TbdLUR01Rlvyy/3CCF1vepteO0WIajb/9tX9HafENbQlq9ga0gI7C8u+LLeHhZC+8RvfRn//kkhuFue8fv6xR8J4e2+c8Xv6dXRq4Sd4Nr73vL/sX7kBmGn6Bj+4YZ/z/oPhjqEHeWazx955MmX19eXnzr50IF2AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4P/ZB7/0rcfPvPLmpc03z/3q8W8N3izsILc//PyW32Xruak/EXaEG+55ye/ppXtuEKK7aeJNv6/zD3YKke26a82XdX5stxDWRxZ8RfO3CkEN/Ie3odkQItr9HW/Pxa8I8Vw97W377lVCMFf/oxPM7hFC2T3jJA8LoXzHie4WArnTqS59Vghj31tO1vywEMSuBWd4Ugjiq87SL4RwU9NZntstRDDhTF8WArjuDWd69Vqhfvc625hQv2Vne1Go3idd4Dahdn/nAt8WaveCCzwrVO6DWy6w9YdC3b7kIgNC3R50kb8W6va4i5wU6vYrF3lGqNuKi/xGqNt5F2kKddt0kYtC3TZd5KJQt/Mu0hTqtuoivxHqdsZF/kWo22Mu8ohQt79xkfuFug26yBeFut285QJbNwuVe94F/lWo3cMu8JBQuz91gV6hei8424tC/e5xtm8K9bu+6Uxv3CAE8KAzPSBE0LnmLK//gRDCV5xlWIhh17wzPL1LCOLW3znZ638shPHpi060eYcQyJed6KtCKH/vJJNCLHtmneDHe4Rg9hzxtn33KiGev3zb23LxbiGkT73mbWjeIQT1oSd9RU/fIsT150u+rPOju4TIdt+16vfVvP9GIbr2bzzv9/TCN68XdoSPTz635XdpPfvt24Qd5OaB+x995tz5zc3z5848+sAXPyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBM/wuP1XCseaaQqgAAAABJRU5ErkJggg=="
    let medkit = "data:image/png;base64,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"
    let car = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAACQFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD////TzK5ZAAAAvnRSTlMAAQIDBAUGBwgJCgsMDQ4PERITFBUWFxgbHB0eHyAhIiMkJScpKisuLzAxMjM0NTc4OTo7Pj9AQURHSU1PUVJTVFVWV1pdXl9hYmNkZmlrbG5vcXN0dXd4ent8fX5/gIGChIeIiYqLjI2Oj5CRkpSWmJmanJ6foKGio6SlpqeosLGytrm9v8HCw8TFxsfJysvMzc7P0NHS09TV1tfb3N3e3+Dh4uPk5ebn6Onq6+zt7u/w8vP19vf4+fr7/P3+1OfRugAAAAFiS0dEv9Pbs1UAAAqRSURBVHja7d35n5VVHcDxZ8YNFBFlrDRJbDEVl1ySrFQWc0nN0BYhA3ELlRQ33DAtqdwAk0BMJTU1wHEoQWYgZv62rH7IDGaee58z3Od8z/v9O6/X/Z7zmbn3e+fOUFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAPDMy9fvnqZ7dsHdq5fyyE/Ts/3Lrl2dXLr5870+2Ob9oly9d+MBbYjrXLL5nmng/srGXr9o0VYN+6pWe57c86Z+XbYwV5696z3fl/HXfdH8aK89pPTnDz/zbrvo/HirT7l6e4/er0x/eNFWvvo18r/PpnrvzHWNH2P/b5gq9/6uKPxor30c1TSr3/C153/f/y5twir//o2/e7+/8YfeDY8u5/zlYX/6lvAsW9NXTlbrf+acOLirr+KY+78s96tKDXgjN+777/30vF/Kxwllf/B35zuJA3Br/6V3d9YO99pYT7P+19N33QAmbHv/+T33LPB/eXWdHvf+ANtzyeN4K/Ejzit+54fM8dGTqAB9zwRB6OfP+L3O/Ebgj84Y89rrfGu8JnRL3/oza53VpvCE0NGsA97raeFTHv/zw//69p/7kR779/nZuta0N/wAC+717ruyre/U/f7lrr2xbvM2I/daud+HG4zwD5GXBHtkdbBW/oaPyhZ25dcN4XZvRF+QTUSd9YcOuvhzo6gh/Euv/D36k/+palcyK+CK765yz7U/1TePvwUMPPrzv3vifPj/zDkAvX1P5VuPmhBn+u3tCjT55aBTf7qdGaPxeONPVZNd8Ev6AqwAU1nwgi/a7Iw7W+/O8+qirCUStL+2DAQJ0fA+9ZWBXjiuE6BzIQZt6ba4z70UVVQebuqnEkN4fZAd+deNiPi7r/qrq4xjfFd6NsggtrPP9fURVmfo1lYEE5O+DKqjj3FbMJ1tgB35haXgBHv1nKJlhjB/xOVaDvFrIJzpz45c4rfSUGUG2Y+APCJ5axAy4s8v7rvDgOsAnW2AHfP6LMAMo4mhqZL64KtaSETfD5iZ/oPldqADXeIs9+E6yxAz5SFWv1xKdzTuYjPhJ/xMn98sh8E5y5p5S3uybtCTLvTXBxOW942wTtgA7IDmgTtAPaBAt6kWtNsgP6Iin025unSTugTdAO6JjsgDZBO6CXSnZAy5Id0JeKHdCTpR3QJmgHdFilfOTZt0s7oBdMdkArkx3QF4wd0FOmHdCLZjugI7MD+qZpByz8ZZMdsPDFyQ5Y9peNHbDwJ047YNkvne2AhR+cHbDwb512wLJfPNkBC1+f7IBlf/HYAQt/+lxiB5zcF9At/2UqO2Dhx2cHLHwTtAOW/RLKDlj4EmUHLPtLyA5Y+JOoHbDsTdAOWPgh2gEL3wTD/+nrQyLfP7BuByx8lVptBzxUX0it/E9W7ICFb4J2wLI3QTtg4UdpByx8E7QDlr0J2gEL3wTtgGVvgnbAwjdBO2DZm6AdsPADtQMWvgk+N8Yh16IXVXPcRi/MyWltJb3WbII1dkAmwZ6BfHZAJkNLNsEaKwuToiWb4AI30SsL7IA2wRx+cMFkacMP2B5yDb3zUO/vf/ou19A7u6b3PID5bqGX5vU8gFUuoZdW9TyAl1xCL73Y8wB2uIRe2tHzAEZcQi8N9zwAd9BbAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAH0IoCK2OcrAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhAAAkAACAABjOPEebes2fDWzr0jO7e+vOaWyweiXWS385URwNkrNo/+7z8b3fSLOXFuv8F8BQRw7E2vHfifvnbTsRFuv9l84QM4ftnOg//joaUzcr/+pvMFD6Dvyg/G/+dDi/pzvv7m88UO4MsvTPyx1+dPyff+E8wXOoDL/lbng8+DF+d6/ynmCxxA/701P/o+fE2W159mvrgBHPlU/d9+eODw/O4/0XxhAzjyN538/sszh2V3/4nmixpA/686+w2oFbl9/081X9QA7h3r0NV5BZBsvqABdP7fTOz9Zk73n26+mAHM/nvnvwY7+KV87j/hfCED6HthrAtr83n/L+F8IQO4trtfhf92LgGknC9iAMcPdndAmzL5sUDS+SIGsKzbv4ZxVR4BJJ0vYADHfNjtAb13dA73n3a+gAH8qPs/iLMohwDSzhcwgNe7P6AtOQSQdr54AZzb5G9indn++088X7wA7m5yQHe2P4DE88UL4NUmB7Sx/QEkni9cACeONjmg0Zltv//U84ULYN5YI5e1PYDU84ULYGmzA/pZ2wNIPV+4ANY0O6DH2x5A6vnCBfByswNa3/YAUs8XLoC3mx3Qn9seQOr5wgUw1OyABtseQOr5wgUw0uyAhtseQOr5BCAATwGeAgIF8E7wF4HveBE4/gPc0OyA1rU9gNTzhQvgyWYH9FjbA0g9X7gAft7sgBa3PYDU84UL4PJmB3Rp2wNIPV+4AAaa/bi09X8+LvV88T4QsrnJAf2xar3E88ULYEWTA7qj/QEkni9eAOc0OaCvtz+AxPPFC6DJh+ay+Fh42vkCBnBT9wd0Yw4BpJ0vYADTBrs9nw+z+NOxaecLGED3H5tbUmUh6XwRA5jxQXfns/24PAJIOl/EAKprujug71WZSDlfyAD6nu/mfH7Xl0sAKecLGUB1yo4uvkGeXGUj4XwxA6guHO70fEYuqjKSbr6gAVRXdXpA11ZZSTZf1ACqezo7n7uqzKSaL2wAhz3Tyfk8nd0fi041X9gAqsNur38+Of65+ETzxQ2gqq7YU/Oz8ldXWUoyX+QAqvO31fqo/EVVplLMFzqA6otra7w/clKVrQTzxQ6gqr71yvj/fOi6vipnjeeLHkDVf+U4v0szuHh6lbmm84UPoKqm/PAgn6N89cZpVQDN5isggE+ccdemz3yaev/GO8+swmgwXxkBfGLgssVPrN86NDIytHXDE0suPaEKptv5igkAASAABIAAEAACQAAIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAATgAQrAAxSABygAD1AAHqAAPEABeIAC8AAF4AEKwAMUgAcoAAEIQAAC6N0DZHIJQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEcCgCqAonAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEEAbz2+k2eMfLj2A7M9vR7MBdpQeQPbn91KzAV4sPYDsz29VswFWlR5A9uc3v9kA80oPIPvzm76ryePfNb30API/vwebDPBgVbzsz2/WcPePf++pAsj//O7ofoA73H+A85uyudvHv3mK649wfrO2d/f4B09z+zHO7/T3u3oT60x3H+X8TtvY+ePf6Os/0PlNva3DH2qM3DbVvYc6v9mrdtd/+LtXzXbp4c7vmIX3r982OtFjH922/v6Fx7hw5wcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIfOPwEGEJ/lPmo1pAAAAABJRU5ErkJggg=="
    let ban = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAADAFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///+zjtKaAAAA/nRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8PT4/QEFCQ0RFRkdISUpLTE1OT1BRUlNUVVZXWFlaW1xdXl9gYWJjZGVmZ2hpamtsbW5vcHFyc3R1dnd4eXp7fH1+f4CBgoOEhYaHiImKi4yNjo+QkZKTlJWWl5iZmpucnZ6foKGio6SlpqeoqaqrrK2ur7CxsrO0tba3ubq7vL2+v8DBwsPExcbHyMnKy8zNzs/Q0dLT1NXW19jZ2tvc3d7f4OHi4+Tl5ufo6err7O3u7/Dx8vP09fb3+Pn6+/z9/u1EEi0AAAABYktHRP+lB/LFAAAdwUlEQVR42u2daXxV1bnGV0ZAAiG1BGIIxAAiJAQkUFACBAnXosYWNSKl5urtbSylEMEhFms9FtqmDkisCmESDtS2caoN2hpmggJGHCDgBRJAIAkggUASTqazf/1w7aAC79p7r7X29Pw/w3mnJ+fsvda73sUYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgH3oGJ86Pnv6Lxaufqd0S3n5Z5VVdXUNmtZQV1dV+Vl5+ZbSd1YvfHx69vjU+I7IlZuI6DvhR/PXlB1u0Lg5f7hszbwfTegbgew5uvKDf+BbtfnzNs0wbUc2r/JNHQwdOI6Y9LyisiZNEK0Vxb6spBCk1RH0zVm4/gtNAl+sX3hPX+TXzoQn5/oPa1KpLclP74BM25Aumb7SRk0JLeWF2Vci43b6y0//9YdBTSnt5fNHhyHzdiA221+nWcL5ktwE5N9SwtJ85UHNSioLMyNRB2uIvGXVWc0GnFl5MxYK1P/tpxee0GxDnT8LGlBIaHphrWYzTvuzwlEZJYx60XbV/3KN4IWRqI5sonM/0mzM3vxvo0YSSStq1GxOoDgTmwZyiMndrTmC/fmxqJZwxhc3a46huXg8Kib0sT9ru+YwPsrBi6EouuQd0RxItS8GtRNAT1+d5lDOFfZG/Uwy1N+iOZiW4u+ghiYY8TfN8bw9HHU0SEpxUHMDpcNQSwMM9LdrLiFYMgT11EliUZvmItqLr0FNddC7qFVzGe3F/VBXTqKfadZcSPPT0agtz6pfTq3mUr7IQx8pScbHmovZexMqfFkS/JrLKUlClS9JZ98FzfU0F3ZFpS/OtGrZua/+dONri+bPzrl5TFragKSkmJjOjHWOiUlKGpCWNvaWnNnzF7+2aXe17EfQ41NR64tw1ZvyVuQry4oLcjOTQjldiUnLzi8qKZfXffROH9T768/+s87LyHTDjiUzx/cKNehTr/Gzlu5skOHXuZmhqPlXlv3fF57jg6/77ugnIM2h/e7wvX5QuHvvJaPq/yIiPyA0ua3lhdndxbrYNdNXKvYJtaUAx8y/5IYKgXmtL/VldpLjZ3haXvFJkc2jaBxkjLGOzwnb9WvZmJ8q2duQIY9uEtai0r4A88jYIFEHPWr92d0ULVdkFopqUqzw+j5xSJ6QH9b2LQ+lqHV88MNbhXxxXZjp6WMksSVC/ozy461wPj6vTETH0rtXebf+NwlY+qvwWTi5K0GEBk7e5tHyX/GS6eTteSTR6iiuftT0O0zwpU5erP/gvWZX+VZcb49IRr9sdtF4b4r36n93g9kf/m/ZJ5iuuR+ai6bpvz1W/vACc6s9Rel2iyi54LSpkIo8dZSwx2YzuaqcGWXHoKJmVZmJalMP79R/uJl1lPIc287iCc3aZiKwY9d7pf65xjsu2ksy7R1bmt/4eYbWfE+Uv9NKwxlqfNEBvfX9FxkfU/+yB/YG4j4wvGq60CG/knHPG97d3tnT7fVPNjrOvaUo3jlR9io0KoFjQ91d/wlnjB6scthVDYYPt537rpvrf2+LwfI78Gil0eOtrbmuLX/IPGN/FH93aPtcyrvGtgZ8Lt0hjlxtrHEq27khZxrbKPqzK18GYjYaycV5n6NbJyPyDE20L3PhwNl4I5t/bUXdnR537FIjnUN74txW/8RKI8vjruiYu26LgdAPuOzs0IDP9efgTK5LHoZCcgzcY/i5q2bKDDpu4Bx1L/fE39PAqffaVPfEn3ZKd/g1d7rrKzDrqO4U1Lnm+on0et2vwv5vMZcRXaj7YfD8je4IfaLujrn9Y934Hjxuv+6ux4mu+PLTvS+ypLM7V8I6L9GbicCtzo86U+/RnzN3M9fyfb0PQ82TnB7yDXrnPqyLZy6mx9t6e2Ac/ms4VOf2byDf5ZMzQvJ0/iLWj3ByuIN1roBUuLwdgjHGkj/R+ZN4nYPX/3TO/FzhiePynVbpXBJx7Jpgb33tX4E85hF0tkUfvdqZYcbr2/85Nop5huH6/jQOOvIE+bf07f9u9NRlizqPRlU48P6xiHU4GncZwgt0nY3f7Li2mJA1utY872KeQ9/xaL/TtsZ19X9WpzEPkqprg9DnrODu09X45dEZKfF6BqQF73VSaBn63nPOjPCmArrouRaxxUFbg4P0nv/xqgLCF+tZFHZMi1BP/ef/vKoAlqfjZeCYQ5rkOpUb6IL1rALu0fFr+YEzpomtMHQaxrMKmKRjnMAaJwQ0w+DBaM8qYKyOlsnp9g9nlOH5L55VwHD+TfOWdLsH0+OY8SlJnlVAMv/I3BqbnxkL32RmUppnFTCAf1GwzN6bJgvNDcz0rAIS+S8lesbOcfxAM8npYR5VQAL3kMmgjTfOUs1fsebZ74Ak7oen87YdmHLFPk2DAoxyTQ13e4hd14MWaRoUYOL7k3va9PM2XdIKalCAGUae430MsOWJsdhaTYMCTDGa9xnqpA0Hiob8TdOgALNforzLqG/br0MsT9OgANPczfsz+jPbrWY2aVCAAJ7gTNAFm3WHdPhY06AAEb+kvMP099jrGN1zmgYFCCFyPWeCFtjJ61Gc82/aoACSrp/y5ad9tI1UyzkSt3rSF1AASSLnkuA++5wWepLz/M8wNhQKoBnBOVXrCbs4fC3n0Iu7GIMCuF4GOQcI2WRXKJTzrrSnGYMChD5Tb7fHPB3OJaANX173BwXQ8DZWzbCDs7355oBV/6uZDQqg4WytPJdgA1//ytfO+h8vLVAAx4s133PV29Z7Oo2vjj/5z/8DBdD8lC87U6z2swtfR/Pqr/4vKICG74DVMavv0f4t38L115uYoACSTnyra/Os9TKJaxJw4JtXv0ABJClcub2QaKmTb3AVcPZF/icUQPIQV27+bKWL47lcfPei7StQALnCVsqVm3HWeRjG1QVw6hJjDqEAiqu4MvRRmGUO3s9Vu0ve/AkFUEzmSs2PrHKvK9e+5eJLfwAUQLGMJzMnoi3y7hke7/7vcve/QAEEUQd4MvM7a5y7mqeHOXj5Gy+gAIIMnjbhgDXXjL7MU7RFxIdAAQRLeRKz1ArP+rfy7AF2Y1CAKaJ59gXbrLhT4g88FZtMfw4UcHnu5MnLKvV+DeJpBH6V55OgAPOrrW0Dlbv1KodbZ/mugIMCLktcHUda/qjaq8HtAlcooADT623BIYqdeovDqU3cR1ihgMsRspUjK2+o9SmN4/W0TYcooYDLcR3H121QbVJ4hgEU6flAKOBy8KwIr1Xp0DAOh+r1TbGAAi5D7FmOpKi8YZRnDWCOzs+EAi7DIxw58atzp1cL7c4B3UcXoYBLE7mfo/Ne3SEBnm3AW/R/LBRwab5vp03BLhy/SOuMfDAUcGn+zvHUpaov4EGOV0BjB1ehAFMrb7PVuBJ+RN4DCRRwSV6hE3JUzSh5jsNgbQMYFCAYnu33qUo8+ZB2ZJnxT4cCLgXH/LByFX5wnAVoTmRQgHCSOF6+MxT4wbEP/JIpA1DAJVhii2NC36YPrl8wecMlFHBxetOpb46V7sXDdE2eM2sDCrg4v6ez8aBsH0I+I31oND/LHAq4KFfRA5n3yR4jPo4uyAsCzEABF4XjsnHZN0uuIT1o78egAElcQy8HSu4P7kYPsXxdjCUo4GL8hUxFU4xUB2bRxbiBQQHSGEOnQu7sQHogwE5htqCAi/A+mYlPZJofRVfiTgYFSOQuOhMyE/ESab1K5LgKKOAbhNGXDEu8VTCsVvEvEBTwDejJzDXyRsbcSDeldGZQgFSi6Nsl5U2NoncjFok2CQXoL8JLskyHnyRti7/9HQr4GiPILJwMl2T6JtL0xxKsQgFfYxeZhQmSLK8gLf+EQQHSmUEmYYkcwxHk9eaN3RgUIJ1ocjm+LlKK4VvI5C+XFDIU8BVWkTm4SYpdP2l3FIMCFJBOpmCFlF8A8jzQbnkxQwH/yV7yN0DGe0AGmfiHGRSghJ+TGZBxrWwBOaMikUEBSkgi57PMl2D1E8rodrlRQwH/ptyCEyJxpOrmMChAEeS8iGCccJv/Q9qUPrEYCvgnvcm/xhzhNskDQWXy44YC/sl2KvpXRFsMI5cBZzEoQBlzqOBPi24KILsR2+MZFKCMXkHVi3K/pgxuURM5FPD/bKNif1KwQXIP8iEGBSjkUSr0HWLtxZBHUpIZFKCQIeRPstiJUbeS42nUxQ4FMMZCyItExO4I/oYyV8SgAKUspwL/lVBzmylzkxkUoJRsKu71Iq1FUE0oLWrvLoQCWDdqaFiDyC3hkVSSNyoOHwpg5C0Sw1UuPD3CoADFPEZFnSfQ2OuUsVQGBSiGvLOhWKCxasLWqRAGBah+EaR2Z46Ls9WXyu9frMiA1xWwloo5UZipe2z3CAAFMDaXCnmaMFOFqsbCQAE6GEtFvECYqQ2EpUBHBgUop1MzEXCpMFOnrG8GggK+CTUv6KQoQ/FUZn/HoAALIK9u6inI0CTK0G0MCrCAyVS4EwUZyqf6gbszKMACYqloRU2OXk3YOWhtHryrgCoi2JWC7FBngl5jUIAlvEnEukuMmQjqdeMJBgVYwq+o13MxO8KptmoGgQL+DdkUMkiIGfKauP4MCrCEAVSkdwsx46NaT0IZFGAJYVSj1uNCzFAjad63RTI8qYAPlAxtohpClzAowCKo1uANQqx8TliZyaAAi3iAiLJKyFtgG2Elg0EBFjGBCLJVxHsg2Q7Ui0EBFtFHRVNQJmGjOZRBAVa9BrQo+Hb+X8LGfjtlxGsKoHYD7hNgYz5h410GBVjGegVTAqirIosYFGDb90AR10hSsyh+zqAAy3hcwdyWw4SNqQwKsIxpChYCGhRPI4ICdDCaiK7evImOqjoPoQADkP26kdJNNIcwKMAyQqmFAPMjY6lpRMdtmRjPKIC6yjPFtAVqufkTBgVYyB7pS4HUbcUbGBRgIdRe/R2mLfxU4RgCKEA31OiO+6UvNSxiUICFUBfJzjVtYSFhYR6DAiyEGuD4rGkL1FbAAwwKsJAHpW8GvE1YyGFQgIXcSwRVYtoCteE4iUEBFkINcTa/WU/NI0xnUICFUHNiNpu2sJOwYPecuVwBo6Qf2viYsDCEQQEWcp30A8LUPbUDGRRgIclEPHtMW6gkLCQxKMBC+hHhHDBt4ahjTgV4UgG9iWiOmLZwgrAQy6AAC+lBBFNr2sJZwkI0gwIsJIaIpc60hSbCQicGBVjIFUQojaYtUEdDwxgUYCFhRCRtEIC7FSBfAC75CXCrAuT/BLjjIdC1CpD/EOiK10D3KkD+a6AbFoJcrAD5C0EuWAp2swLkLwU7fzPI1QqQvxnk+O1gdyuAuj3Q/Haw0xtCXK4A+Q0hDm8Jc7sC5LeEUU2hNzMowEJuk94U6ui2cPcrQH5bOHVfzGwGBVjIw4TzK01beI6wMJ9BARZSQPj+jGkLvyAsLGZQgIUslT7DbTph4VUGBVjIG4TnuaYtUPfSbGRQgIVsIRy/3bSFGwkLnzIowEIqCL/HmbZA3RlWzaAAC6F265NNW3DkmDjPKEDBmLgODhwU6R0FKBgUyc4TJkYxKMAy0gmXzwqwcYiwMZVBAZbxQ8LjSgE2nDYu3lMKUDEu3mEXRnhLASoujHDWlTEeU8AGwl0RV8Y46tIorymAujTqXgE2qGnRdro2zmsKCFdxbRx5cWQ8gwIsIpHytY8AI865OtZ7ClBydSw7QliZyaAAi5hDOCrk8minXB/vRQW8TPi5XoiVlYSV7QwKsIhyws3lQqz4CCsNoVCANYRRwxseF2JmKpWM/gwKsIQBlJNThJhJoczczqAAS6DucxJ0cjc8QJjxMSjAEuYRHgbCxdihDgi/zqAAS3iLcLBckB0/YecggwIsgdoJWCnIDnX8KBgLBVgBNR9ImyPI0E2Uoe8xKMAC7qC8yxRkKI4y9BSDAixgAeWcsG/mk4ShbQwKsIAdhGsnhVmihkQEOkIB6unUrKxXizoiro1mUIByMijHnhFm6h7K1CMMClDOXMqvacJMJVGm3mJQgHLeUdEO9CXVhKlTIVCAakJPE04dF2jsNSoDqQwKUEwa5dOfBBqb7bmHAPsrgJrdI7RV7zuUsY0MClDsXRnl0TCBxiIaCWMt0VCAWgXEtFKNWuEizW2kwp/MoAClCiCbQdYJNUcdEHRJa7CDFLCC8sYn1NwkytxRBgWoVEDIccqZiWJ/cdopeylQgEoFDKVcaesq1iDVga49xKAAhQp4lPJE9GkNqv9Q28qgAIUKeE/tIwBjoymDwd5QgDoFJAQpP0YKthhGrTxrDzAoQJkCHqK8OC38St9iyuR7DApQpgDqJiftD8JN3kf+BiRCAaoUcDX5C3CPcJs9g559D7CfAsh3gGAP8Uap80HaTgYFKFLALsqBcglGf0uG3RcKUKMAcmyTNk+C1XGk1XwGBShRwGOkeRlduhFnKKt7GBSgRAH7yJfAcBlmV5JB3wAFqFDAGNL2Mil2yR1B7WUGBShQgJ80PVGK3Qgy+qZuUIB8BURT7VnaqXA50S8jQ57OoADpCphB2pV1l+NE0vInDAqQrgByEUAbLyn2sBOk6TQoQLYCRpBGa8Nkxb7Ysi8fKOBfLCFtviAt9PGk7fooKECuAqLOkSbHSos8tJo0PotBAVIV8ABpsFri5NYXSOuHwqEAmQoIqyTtLZQY+Eg63GwGBUhUwN2atQ/iH5HmdzIoQKICtlv8Kj6TjjYdCpCngAzN4sW4buQypPYmgwKkKaCEtCR7OX416UFwIBQgSwEDyANawsbDXoqxdKyLGBQgSQH0IpD0gW0hn9FfQnFQgBwFxF8greyVHvTDdKiFDAqQooAXaSNzpMf87QDpRCABCpChgN506pu7y4/5VTwFWKSApbSFPykImd4R0pqvhgLEK6BvC20gQ0XIO2g/ljMoQLgCVtEf/4GSiH9AO9I2AAoQrYD+rfSnT1EScPhh2pPVDAoQrIA/0p99WNFW7ByOr4AUKECsAlLpRUBlIxq6nKF9Wc+gAKEKeJf+4PququJ9iiPM26AAkQq4neNzf6ss3Phm2puDHaAAcQqI3E9/aksvdeGu5ojyIQYFCFPAzzk+VOXBvNQg7c+5OChAlAJ61HN85hCV0b7N4dBSBgUIUsAKjk8sURpsGsdXQPtwKECMAoZxvAIGFd9X8CZHjFtCoAARCgjdxvFxrymONYVDlNqPGRQgQAHTOT6sXfmtTcUcXp2NhwLMKyCOY91Ne0V5qNe02fB7yZUK4Pm1bbtWfahreEKcDAWYVUA2zwettCDSfhzbk1p1DBRgTgHRxzg+psWSEY3LeSJczKAAUwpYxvMpRZYEmsixI6AFx0EBZhQwnmPBRQtYdFfD0zwB7u8MBRhXQNQBno8osCjOLjU83i1hUIBhBXD9zNZ2tSrOH3MFeBcUYFQBk7n+/32WhRn6AY9/dQlQgDEFxHN9yK5Q68IczfOIom0KhQKMKCB0Hdd/HmNlmK9yufgggwIMKCCf67++YmmUCY08PgaGQgH6FTCM5zVba+pjbZS/5gqv4gooQK8COu/j+n9PWhxk1HEuN9cwKECnAlZy/a+jli+zTOUL76dQgD4FzOT7T3daH+RbXI62jIEC9Cjgeq4HAG2tDWLsfY7L1ZqroAB+BfQ4xvUf6nvZIUbOL6ttkVAArwIiNvP9e3tc0BFaxuftcwwK4FRAId+/ft8mK2zXBvj8zYEC+BTA+WAdGGSXEH18DjcMhwJ4FDCike+fPm6bCCP38Hlc0wcKoBVwWw3fP9xno+O3I9v5fN4bAwXQHb58/6x9tJ0ifI4zuPWRUIAgnrVVgB0+5nT7lRAoQAi7O9orwEFNnI7/kkEBArgw2G4BzuL0PJgDBQhghu3iC3mH0/Xmm6EA06y14S9pLOfbi9Y0Hgowycmedozvu0FO9xvToQBTBG+1Z3wv8gZwNg0KMINdL2To+Cn3V9ggKMA4FZ3sGt619bwxHEuCAoxyPtm+4U3hjqIqwaMKGHba7AOAre9mXcAdx+F++A4wxFO2ji58I3cgNSlQgAE22Px27tij3KGcHgEF6ObzWLtHNzLAHcyZ66EAnbSMtn900/nDaciEAvThiMmLy/njCXwPCtCD3xHBddrJH1HzPVAAPzs6OiO47gd1vNX60CHCy6EeTgluYJ2OsFaiS4yP+sHOCW5cQEdg67tBATwvABOcFNzUoI7QKhK9qYBb2vSsADusk8qnR9w1njwxMqJWT46c1ksZ4tcTXcPd3qv/tEY9GVrpuGfliHW6fuGKIrxV/vACXenZ5MBL+GL26Apxc08v1T9uq75DAI58To79TFeQx2/wTv1HV+tKzQGH3sCXcEhXmK35Xql/brOuxBx17FtS/xqdS92emCbXeY2+rNT0d26sKTpXu/YNc3/9Uz7Vl5Mzjp6yObROX7QtPpfPFQ7Ja9a5AOzwtpnrz+tc8V7fy8317/k3neloHOv0kCdc0Bnymanurf/tejeAmic5P+hbAzqD1pZFubP8Ucv0ZiKQ5Ya4JzbojftAhhvrP/6A3jw0THRH5OlndR9+8F/ptvJ3K2zXm4XzrjlGPeyU7u6XGpfNkcg6qjsFdSPdE/7A47rD10pcdHgs7jX98demuukP4Ooq/Rk4m+eSNYGQHAPnAY/0d9dXYJ+D+nOgbXXFwuDwbQZC39+buYyrKgykoX1ZD6fHHbei3UDgu+OY64jZYOQoRIOvo5ODjsirNxK1O/tkI1cZOg1zxMHvA1kHDYXs1k75EF/QUD7WDXZmvKnrjU2AeMK9Z2Vymg2lpL14gANffIraDAXr7tNyN57RDErAYW9FfYpajUVa5/IpioMOGcuL1uJ30FyphMKAwTCrBjKX03OnwdRogd875N0o/sVmozHu6MFcT8eXDc9HaVp8jf3ju7boguEAV3RkXiCnyXCG2kttvkOeXtxmOLhAHvMIaYdNjMnalWPbOVmhWe+ZCOzYKOYZemw0kSitapYtW4aiZlWZiWpDLPMQYQVBM8k657fdeKm0QnMjQL12OJJ9r95UvrSKfBs1DUXnfmgumvN3Mc+RXGEuZ1rTKpvcOzBmVZPJUHZ7cnp6pxeCJvOm7Z1r+cThfnP3mY0i+HxH5k3+q1ozTYXPwkXi3nllpkWsnbiVeZbuf9U0ERroa4XzvURUX9P+Hsc8TMjPmkRIILgtf4hav4c++p6I6mtNM0KYtxm4SxPDieIcRTcTd84q+lyQ03tSmefp8Gy7oGxqrVvnDpPcSRw6bO7WVlH+tj/TAfVnjF2/RxPHuVJfpqRLlSLS8opFXv+5exRq/2Vm8wOaSFrLC3MEt1XHZvlKLwh1sqUAf/7/ZlCZJprKN3+VPSBMwKr1gOx5b1YKd2/rQFT9K7+tM+o1CTR9sPyBCX0MyiC8z4TZK8qbZPhVPz0UNf8aca9rsmipLi8uyM1M4hVCTFp2flFpRZM0h9b2Rr0vwpRjmlxaavZsfmPpbx6899Yb09KSk5KujIliLCrmyqSk5LS0G7PuffA3S9/YvKemVbIbR7NR64tzha9Jcz1NBV1Q6Usvr/qDLq9/SSKqfFm+876by//hGFSYXGbPqXFr+U/lhaG+HHT9XcCN5Q/gx58b4ydrbIujTjbZAMNn6+yJ48422oBr/W3uKf8A1NPIBkGxK94JgyXXoZYGSVuL8nuc1KILTi5/c/EI1NAkPX2nnVr++sIE1E8AUXmHnVj+Q/ndUDtBhGY5boHYxoeYnUnGn5udU/3An8ahYsKJyf3UGeX/LD8W1ZL0WljUYPfqXyjODEGh5BGdu8vO5bfVoXW3MuL5antW/3jhcFRHzUtBeqHtega+8GfhsV+tBmrtU/06f1YEaqKaiO+uqLND9U8vvwl/+xYRlpZf1m7tU19BJv72raV7dpFFDwRfFOfGI/+2+CIY9eQOxd0jbdufGInTXXYiKj2/5Iya4jeUFWTFION2/CZIzvUfklv86pL89Ehk2s4k/vDZ0hMyan+i9NlpicivM4hJzysqaxTW0l1R7MtCV7fjCB805ZcrNlSZ6C9vrdqw4vEpA/Ga72wdJGbc96R/a9U5/sKfq9zif/K+jERU3lVExqWMu/3+xxasWlu6oby8orLydN15TTtfd7qysqK8fEPp2lULHrv/9nEpcXjKAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJ34B7flqwuAdEsPAAAAAElFTkSuQmCC"
    let leaf = "data:image/png;base64,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"
    let globe = "data:image/png;base64,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"


    //console.log(pdf.getFontList());
    autoTable(pdf,
      {
        theme: 'grid',
        html: '#printable',
        styles: { overflow: 'linebreak', fontSize: 7, font: 'Bitter-Regular', halign: 'center', valign: 'middle' },
        headStyles: { fillColor: [56, 128, 255], fontStyle: 'bold', font: 'Bitter-Bold' }, /*alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,*/
        didDrawCell: (data) => {
          //console.log(data)
          const cell = data.cell;
          //console.log(cell.raw)
          if (cell.text[0] == '  ') {
            pdf.setFillColor("#d3d3d3"); // Set the background color
            pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
          } else if (cell.text[0] == '') {
            if (cell.raw["outerHTML"].includes("alert"))
              pdf.addImage(alert, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("bed")) {
              console.log("bed!")
              pdf.addImage(bed, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            } else if (cell.raw["outerHTML"].includes("medkit"))
              pdf.addImage(medkit, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("leaf"))
              pdf.addImage(leaf, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("car"))
              pdf.addImage(car, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("ban"))
              pdf.addImage(ban, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("globe"))
              pdf.addImage(globe, 'PNG', cell.x + cell.width / 2 - 1.5, cell.y + 2, 3, 3);
            else if (cell.raw["outerHTML"].includes("hourglass") || cell.raw["outerHTML"].includes("close") || cell.raw["outerHTML"].includes("create")) {
              pdf.setFillColor("#d3d3d3"); // Set the background color
              pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
            }

            //pdf.text("!",cell.x+2, celltextPos.y + (cell.height - imageHeight) / 2);
          } else {
            //pdf.text("!",cell.x+2, cell.y+2);
          }
          /*if (data.section === 'body' && data.column.index === 0) {
            var base64Img = 'data:image/jpeg;base64,iVBORw0KGgoAAAANS...'
            pdf.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10)
          }*/
        },
        didParseCell: (data) => {

        },
        didDrawPage: (data) => {
          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          var pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          pdf.setFontSize(8);
          var img = new Image(); //this mount a variable to img
          img.src = '/assets/icon/favicon.png' //asign the src to the img variable
          pdf.addImage(img, 'png', data.settings.margin.left, pageHeight - 15, 10, 10)// use the method doc.autoTable.previous.finalY + lineHeight * 1.5 + offsetY to be able to position the image of the signature below the table at a safe distance from it

          pdf.text("Készült a Sulinform ERP rendszerében " + moment().format("YYYY-MM-DD HH:mm") + ". Generálta: " + this.sajatnev, data.settings.margin.left + 10, pageHeight - 10);
          pdf.text(data.pageNumber + "", pageWidth - 20, pageHeight - 10);
        },
      })

    //table.fromHTML()
    pdf.save(this.selectedYear + "-" + this.selectedMonth + "_" + this.sajatIntezmeny.intezmenyName + ".pdf")

  }










  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }






  async hazikuldes() {
    await this.datas.showLoading("Fájlok feltöltése...")
    const formData = new FormData();

    // If files is a FileList
    const fileArray = Array.from(this.files as ArrayLike<File>);

    for (const file of fileArray) {
      formData.append('files', file, file.name);
    }

    formData.append('tanora', this.tanoraformelleklet.id);
    formData.append('intezmeny', this.sajatIntezmeny?.intezmenyId || '');
    formData.append('regifajlok', this.regifajlok ? this.regifajlok.map(d => d.name) : "");
    //formData.append('regifajlok',new Blob([JSON.stringify(this.regifajlok)], { type: 'application/json' }))

    this.http
      .post(
        '/api/hazifeladatfile',
        formData,
        {
          //headers: {regifajlok:this.regifajlok.map(d=>d.name)},
        }
      )
      .subscribe({
        next: (response) => {
          this.datas.hideLoading()
          this.getData(this.selectedYear, this.selectedMonth);
          this.hazifeladatmodal.dismiss()
        },
        error: (error) => {
          this.datas.hideLoading()
          this.datas.sendToast("Hiba történt: " + error.message, "error")
          console.error('Error fetching data:', error);
        },
      });


  }





  onFileChange(event: any) {
    try {
      console.log(event)
      const file = event.target.files[0];
      const reader = new FileReader();
    } catch (e) {
      console.log(e)
    }
  }




  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {

    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      const files: any = inputElement.files;
      // Now you can handle the files as needed
      this.prepareFilesList(files, event);
    }

  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    //this.files = [];
    //(<HTMLInputElement>document.getElementById("fileDropRef")).value = null;
    //this.files.splice(this.files.indexOf(index-1 || 0), 1)

    this.files.splice(index, 1);
  }
  deleteRFile(index: number) {
    //this.files = [];
    //(<HTMLInputElement>document.getElementById("fileDropRef")).value = null;
    //this.files.splice(this.files.indexOf(index-1 || 0), 1)

    this.regifajlok.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number, event) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            this.onFileChange(event);
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1, event);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<any>, event = null) {
    //for (const item of files) {
    //this.cdis = true;
    const item = files[0]
    item.progress = 0;
    this.files.push(item)
    //this.files[0] = item;
    //await this.data.getAllomany((await this.data.getFromStorage("sajatIntezmeny")).intezmenyId).subscribe(data => this.allomany = data)
    this.uploadFilesSimulator(this.files.length - 1 || 0, event);


    //}

  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }




  openLink(key) {
    /*  A tárolt fájlnév szóközt és ékezetet is tartalmazhat („5. z nyelvtan házi.jpg"),
     *  ezért szakaszonként kódoljuk – a perjelek maradnak útvonal-elválasztónak.
     *  Kódolatlanul a megnyitás natív alkalmazásban hibára futott. */
    const ut = '/api/file/' + String(key || '').split('/').map(encodeURIComponent).join('/');
    // Weben új fül, natíven beépített néző (tokennel letöltött blob) – relatív /api forma a tokenhez.
    this.datas.megnyitFajl(ut, 'Fájl');
  }


  /**
   *  Tanmenet feltöltése.
   *
   *  Régen egy külső n8n-űrlapot nyitott új ablakban – az felugró-ablak-tiltásba
   *  ütközött, és semmi visszajelzést nem adott. A rendszernek azóta saját
   *  Tanmenet képernyője van, oda navigálunk.
   */
  initTanmenet() {
    this.router.navigate(['/tanmenet']);
  }






  protected readonly Math = Math;

}
interface Day {
  dayNumber: number;
  dayName: string;
  dayDate: Date;
  isWeekend: boolean;
  nyilvantartas: any;
  isHoliday: any;
  week: any;
}

